import {
  createUseReadContract,
  createUseSimulateContract,
  createUseWatchContractEvent,
  createUseWriteContract,
} from "wagmi/codegen";

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Aquabera
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const aquaberaAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "_ICHIVaultFactory", internalType: "address", type: "address" },
      { name: "_WRAPPED_NATIVE", internalType: "address", type: "address" },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "_ICHIVaultFactory",
        internalType: "address",
        type: "address",
        indexed: false,
      },
      {
        name: "_WETH",
        internalType: "address",
        type: "address",
        indexed: false,
      },
    ],
    name: "Deployed",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "vault",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "token",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "shares",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      { name: "to", internalType: "address", type: "address", indexed: false },
    ],
    name: "DepositForwarded",
  },
  {
    type: "function",
    inputs: [],
    name: "ICHIVaultFactory",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "WRAPPED_NATIVE",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "vault", internalType: "address", type: "address" },
      { name: "vaultDeployer", internalType: "address", type: "address" },
      { name: "token", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
      { name: "minimumProceeds", internalType: "uint256", type: "uint256" },
      { name: "to", internalType: "address", type: "address" },
    ],
    name: "forwardDepositToICHIVault",
    outputs: [{ name: "vaultTokens", internalType: "uint256", type: "uint256" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "vault", internalType: "address", type: "address" },
      { name: "vaultDeployer", internalType: "address", type: "address" },
      { name: "minimumProceeds", internalType: "uint256", type: "uint256" },
      { name: "to", internalType: "address", type: "address" },
    ],
    name: "forwardNativeDepositToICHIVault",
    outputs: [{ name: "vaultTokens", internalType: "uint256", type: "uint256" }],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [
      { name: "vault", internalType: "address", type: "address" },
      { name: "vaultDeployer", internalType: "address", type: "address" },
      { name: "shares", internalType: "uint256", type: "uint256" },
      { name: "to", internalType: "address", type: "address" },
      { name: "minAmount0", internalType: "uint256", type: "uint256" },
      { name: "minAmount1", internalType: "uint256", type: "uint256" },
    ],
    name: "forwardNativeWithdrawFromICHIVault",
    outputs: [
      { name: "amount0", internalType: "uint256", type: "uint256" },
      { name: "amount1", internalType: "uint256", type: "uint256" },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "vault", internalType: "address", type: "address" },
      { name: "vaultDeployer", internalType: "address", type: "address" },
      { name: "shares", internalType: "uint256", type: "uint256" },
      { name: "to", internalType: "address", type: "address" },
      { name: "minAmount0", internalType: "uint256", type: "uint256" },
      { name: "minAmount1", internalType: "uint256", type: "uint256" },
    ],
    name: "forwardWithdrawFromICHIVault",
    outputs: [
      { name: "amount0", internalType: "uint256", type: "uint256" },
      { name: "amount1", internalType: "uint256", type: "uint256" },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "vaultDeployer", internalType: "address", type: "address" },
      { name: "token0", internalType: "address", type: "address" },
      { name: "token1", internalType: "address", type: "address" },
      { name: "fee", internalType: "uint24", type: "uint24" },
      { name: "allowToken0", internalType: "bool", type: "bool" },
      { name: "allowToken1", internalType: "bool", type: "bool" },
    ],
    name: "vaultKey",
    outputs: [{ name: "key", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view",
  },
  { type: "receive", stateMutability: "payable" },
] as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const aquaberaAddress = {
  80094: "0xc0c6D4178410849eC9765B4267A73F4F64241832",
} as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const aquaberaConfig = {
  address: aquaberaAddress,
  abi: aquaberaAbi,
} as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Auction
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const auctionAbi = [
  {
    type: "constructor",
    inputs: [
      {
        name: "beneficiaryAddress_",
        internalType: "address payable",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
  },
  { type: "receive", stateMutability: "payable" },
  {
    type: "function",
    inputs: [],
    name: "auctionEndThresholdHrs",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "auctionLengthInHours",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "auctionStart",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "auctionStatus",
    outputs: [
      {
        name: "",
        internalType: "struct Auction.AuctionStatus",
        type: "tuple",
        components: [
          { name: "started", internalType: "bool", type: "bool" },
          { name: "ended", internalType: "bool", type: "bool" },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "beneficiaryAddress",
    outputs: [{ name: "", internalType: "address payable", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "refundAmount_", internalType: "uint256", type: "uint256" },
      { name: "proof_", internalType: "bytes32[]", type: "bytes32[]" },
    ],
    name: "claimRefund",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "endAuction",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "endWindows",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "auctionIndex_", internalType: "uint256", type: "uint256" },
      { name: "bidder_", internalType: "address", type: "address" },
    ],
    name: "getBid",
    outputs: [
      {
        name: "",
        internalType: "struct Auction.Bid",
        type: "tuple",
        components: [
          { name: "unitPrice", internalType: "uint128", type: "uint128" },
          { name: "quantity", internalType: "uint128", type: "uint128" },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "itemsPerAuction",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "maximumQuantity",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "minimumBidIncrement",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "minimumQuantity",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "minimumUnitPrice",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "numberOfAuctions",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "numberOfBidsPlaced",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "paused",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "auctionIndex_", internalType: "uint256", type: "uint256" },
      { name: "quantity_", internalType: "uint256", type: "uint256" },
      { name: "unitPrice_", internalType: "uint256", type: "uint256" },
    ],
    name: "placeBid",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [],
    name: "refundMerkleRoot",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "refundMerkleRoot_", internalType: "bytes32", type: "bytes32" }],
    name: "setRefundMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "startAuction",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "token", internalType: "contract IERC20", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "transferERC20Token",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "unitPriceStepSize",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "withdrawContractBalance",
    outputs: [],
    stateMutability: "nonpayable",
  },
  { type: "event", anonymous: false, inputs: [], name: "AuctionEnded" },
  { type: "event", anonymous: false, inputs: [], name: "AuctionStarted" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "bidHash",
        internalType: "bytes32",
        type: "bytes32",
        indexed: true,
      },
      {
        name: "auctionIndex",
        internalType: "uint256",
        type: "uint256",
        indexed: true,
      },
      {
        name: "bidder",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "bidIndex",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "unitPrice",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "quantity",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "balance",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "BidPlaced",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "previousOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OwnershipTransferred",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: false,
      },
    ],
    name: "Paused",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "refundRecipient",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "refundAmount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "RefundIssued",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: false,
      },
    ],
    name: "Unpaused",
  },
  {
    type: "error",
    inputs: [{ name: "target", internalType: "address", type: "address" }],
    name: "AddressEmptyCode",
  },
  {
    type: "error",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "AddressInsufficientBalance",
  },
  { type: "error", inputs: [], name: "EnforcedPause" },
  { type: "error", inputs: [], name: "ExpectedPause" },
  { type: "error", inputs: [], name: "FailedInnerCall" },
  {
    type: "error",
    inputs: [{ name: "owner", internalType: "address", type: "address" }],
    name: "OwnableInvalidOwner",
  },
  {
    type: "error",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "OwnableUnauthorizedAccount",
  },
  {
    type: "error",
    inputs: [{ name: "token", internalType: "address", type: "address" }],
    name: "SafeERC20FailedOperation",
  },
] as const;

/**
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const auctionAddress = {
  11155111: "0x01658783645a0c6cC0e658669486d4e98f0f8865",
} as const;

/**
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const auctionConfig = {
  address: auctionAddress,
  abi: auctionAbi,
} as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BeradromePlugin
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const beradromePluginAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "_token", internalType: "address", type: "address" },
      { name: "_voter", internalType: "address", type: "address" },
      { name: "_assetTokens", internalType: "address[]", type: "address[]" },
      { name: "_bribeTokens", internalType: "address[]", type: "address[]" },
      { name: "_vaultFactory", internalType: "address", type: "address" },
      { name: "_protocol", internalType: "string", type: "string" },
      { name: "_name", internalType: "string", type: "string" },
      { name: "_vaultName", internalType: "string", type: "string" },
    ],
    stateMutability: "nonpayable",
  },
  { type: "error", inputs: [], name: "Plugin__InvalidZeroInput" },
  { type: "error", inputs: [], name: "Plugin__NotAuthorizedVoter" },
  {
    type: "event",
    anonymous: false,
    inputs: [],
    name: "Plugin__ClaimedAnDistributed",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Plugin__Deposited",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Plugin__Withdrawn",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "claimAndDistribute",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "depositFor",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "getAssetTokens",
    outputs: [{ name: "", internalType: "address[]", type: "address[]" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "getBribe",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "getBribeTokens",
    outputs: [{ name: "", internalType: "address[]", type: "address[]" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "getGauge",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "getName",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "getProtocol",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "getRewardVault",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "getToken",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "getVaultToken",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "getVoter",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "_bribe", internalType: "address", type: "address" }],
    name: "setBribe",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_gauge", internalType: "address", type: "address" }],
    name: "setGauge",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "withdrawTo",
    outputs: [],
    stateMutability: "nonpayable",
  },
] as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Bgt
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const bgtAbi = [
  { type: "error", inputs: [], name: "AmountLessThanMinIncentiveRate" },
  { type: "error", inputs: [], name: "CannotRecoverIncentiveToken" },
  { type: "error", inputs: [], name: "CannotRecoverRewardToken" },
  { type: "error", inputs: [], name: "CannotRecoverStakingToken" },
  { type: "error", inputs: [], name: "CheckpointUnorderedInsertion" },
  { type: "error", inputs: [], name: "DepositNotMultipleOfGwei" },
  { type: "error", inputs: [], name: "DepositValueTooHigh" },
  { type: "error", inputs: [], name: "DonateAmountLessThanPayoutAmount" },
  { type: "error", inputs: [], name: "ECDSAInvalidSignature" },
  {
    type: "error",
    inputs: [{ name: "length", internalType: "uint256", type: "uint256" }],
    name: "ECDSAInvalidSignatureLength",
  },
  {
    type: "error",
    inputs: [{ name: "s", internalType: "bytes32", type: "bytes32" }],
    name: "ECDSAInvalidSignatureS",
  },
  {
    type: "error",
    inputs: [
      { name: "increasedSupply", internalType: "uint256", type: "uint256" },
      { name: "cap", internalType: "uint256", type: "uint256" },
    ],
    name: "ERC20ExceededSafeSupply",
  },
  {
    type: "error",
    inputs: [
      { name: "spender", internalType: "address", type: "address" },
      { name: "allowance", internalType: "uint256", type: "uint256" },
      { name: "needed", internalType: "uint256", type: "uint256" },
    ],
    name: "ERC20InsufficientAllowance",
  },
  {
    type: "error",
    inputs: [
      { name: "sender", internalType: "address", type: "address" },
      { name: "balance", internalType: "uint256", type: "uint256" },
      { name: "needed", internalType: "uint256", type: "uint256" },
    ],
    name: "ERC20InsufficientBalance",
  },
  {
    type: "error",
    inputs: [{ name: "approver", internalType: "address", type: "address" }],
    name: "ERC20InvalidApprover",
  },
  {
    type: "error",
    inputs: [{ name: "receiver", internalType: "address", type: "address" }],
    name: "ERC20InvalidReceiver",
  },
  {
    type: "error",
    inputs: [{ name: "sender", internalType: "address", type: "address" }],
    name: "ERC20InvalidSender",
  },
  {
    type: "error",
    inputs: [{ name: "spender", internalType: "address", type: "address" }],
    name: "ERC20InvalidSpender",
  },
  {
    type: "error",
    inputs: [
      { name: "timepoint", internalType: "uint256", type: "uint256" },
      { name: "clock", internalType: "uint48", type: "uint48" },
    ],
    name: "ERC5805FutureLookup",
  },
  { type: "error", inputs: [], name: "ERC6372InconsistentClock" },
  { type: "error", inputs: [], name: "IncentiveRateTooHigh" },
  { type: "error", inputs: [], name: "IndexOutOfRange" },
  { type: "error", inputs: [], name: "InsolventReward" },
  { type: "error", inputs: [], name: "InsufficientDelegateStake" },
  { type: "error", inputs: [], name: "InsufficientDeposit" },
  { type: "error", inputs: [], name: "InsufficientSelfStake" },
  { type: "error", inputs: [], name: "InsufficientStake" },
  {
    type: "error",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "currentNonce", internalType: "uint256", type: "uint256" },
    ],
    name: "InvalidAccountNonce",
  },
  { type: "error", inputs: [], name: "InvalidActivateBoostDelay" },
  { type: "error", inputs: [], name: "InvalidBaseRate" },
  { type: "error", inputs: [], name: "InvalidBoostMultiplier" },
  { type: "error", inputs: [], name: "InvalidCredentialsLength" },
  { type: "error", inputs: [], name: "InvalidDropBoostDelay" },
  { type: "error", inputs: [], name: "InvalidInitialization" },
  { type: "error", inputs: [], name: "InvalidMaxIncentiveTokensCount" },
  { type: "error", inputs: [], name: "InvalidMinBoostedRewardRate" },
  { type: "error", inputs: [], name: "InvalidProof" },
  { type: "error", inputs: [], name: "InvalidPubKeyLength" },
  { type: "error", inputs: [], name: "InvalidRewardAllocationWeights" },
  { type: "error", inputs: [], name: "InvalidRewardConvexity" },
  { type: "error", inputs: [], name: "InvalidRewardRate" },
  { type: "error", inputs: [], name: "InvalidSignatureLength" },
  { type: "error", inputs: [], name: "InvalidStartBlock" },
  { type: "error", inputs: [], name: "InvalidateDefaultRewardAllocation" },
  { type: "error", inputs: [], name: "InvariantCheckFailed" },
  { type: "error", inputs: [], name: "MaxNumWeightsPerRewardAllocationIsZero" },
  { type: "error", inputs: [], name: "MinIncentiveRateIsZero" },
  { type: "error", inputs: [], name: "NotAContract" },
  { type: "error", inputs: [], name: "NotApprovedSender" },
  { type: "error", inputs: [], name: "NotBGT" },
  { type: "error", inputs: [], name: "NotBlockRewardController" },
  { type: "error", inputs: [], name: "NotDelegate" },
  { type: "error", inputs: [], name: "NotDistributor" },
  { type: "error", inputs: [], name: "NotEnoughBalance" },
  { type: "error", inputs: [], name: "NotEnoughBoostedBalance" },
  { type: "error", inputs: [], name: "NotEnoughTime" },
  { type: "error", inputs: [], name: "NotFactoryVault" },
  { type: "error", inputs: [], name: "NotFeeCollector" },
  { type: "error", inputs: [], name: "NotIncentiveManager" },
  { type: "error", inputs: [], name: "NotInitializing" },
  { type: "error", inputs: [], name: "NotNewOperator" },
  { type: "error", inputs: [], name: "NotOperator" },
  { type: "error", inputs: [], name: "NotWhitelistedVault" },
  { type: "error", inputs: [], name: "OperatorAlreadySet" },
  {
    type: "error",
    inputs: [{ name: "owner", internalType: "address", type: "address" }],
    name: "OwnableInvalidOwner",
  },
  {
    type: "error",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "OwnableUnauthorizedAccount",
  },
  { type: "error", inputs: [], name: "PayoutAmountIsZero" },
  { type: "error", inputs: [], name: "RewardAllocationAlreadyQueued" },
  { type: "error", inputs: [], name: "RewardAllocationBlockDelayTooLarge" },
  { type: "error", inputs: [], name: "RewardCycleNotEnded" },
  { type: "error", inputs: [], name: "RewardsDurationIsZero" },
  {
    type: "error",
    inputs: [
      { name: "bits", internalType: "uint8", type: "uint8" },
      { name: "value", internalType: "uint256", type: "uint256" },
    ],
    name: "SafeCastOverflowedUintDowncast",
  },
  { type: "error", inputs: [], name: "StakeAmountIsZero" },
  { type: "error", inputs: [], name: "TimestampAlreadyProcessed" },
  { type: "error", inputs: [], name: "TokenAlreadyWhitelistedOrLimitReached" },
  { type: "error", inputs: [], name: "TokenNotWhitelisted" },
  { type: "error", inputs: [], name: "TooManyWeights" },
  { type: "error", inputs: [], name: "TotalSupplyOverflow" },
  {
    type: "error",
    inputs: [{ name: "expiry", internalType: "uint256", type: "uint256" }],
    name: "VotesExpiredSignature",
  },
  { type: "error", inputs: [], name: "WithdrawAmountIsZero" },
  { type: "error", inputs: [], name: "ZeroAddress" },
  { type: "error", inputs: [], name: "ZeroOperatorOnFirstDeposit" },
  { type: "error", inputs: [], name: "ZeroPercentageWeight" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      { name: "user", internalType: "address", type: "address", indexed: true },
      { name: "pubkey", internalType: "bytes", type: "bytes", indexed: true },
      {
        name: "amount",
        internalType: "uint128",
        type: "uint128",
        indexed: false,
      },
    ],
    name: "ActivateBoost",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "newDelay",
        internalType: "uint32",
        type: "uint32",
        indexed: false,
      },
    ],
    name: "ActivateBoostDelayChanged",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "spender",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "value",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Approval",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "newTermsAndConditions",
        internalType: "string",
        type: "string",
        indexed: false,
      },
    ],
    name: "BgtTermsAndConditionsChanged",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      { name: "pubkey", internalType: "bytes", type: "bytes", indexed: true },
      {
        name: "amount",
        internalType: "uint128",
        type: "uint128",
        indexed: false,
      },
    ],
    name: "CancelBoost",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      { name: "pubkey", internalType: "bytes", type: "bytes", indexed: true },
      {
        name: "amount",
        internalType: "uint128",
        type: "uint128",
        indexed: false,
      },
    ],
    name: "CancelDropBoost",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "delegator",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "fromDelegate",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "toDelegate",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "DelegateChanged",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "delegate",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "previousVotes",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "newVotes",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "DelegateVotesChanged",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      { name: "user", internalType: "address", type: "address", indexed: true },
      { name: "pubkey", internalType: "bytes", type: "bytes", indexed: true },
      {
        name: "amount",
        internalType: "uint128",
        type: "uint128",
        indexed: false,
      },
    ],
    name: "DropBoost",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "newDelay",
        internalType: "uint32",
        type: "uint32",
        indexed: false,
      },
    ],
    name: "DropBoostDelayChanged",
  },
  { type: "event", anonymous: false, inputs: [], name: "EIP712DomainChanged" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "caller",
        internalType: "address",
        type: "address",
        indexed: false,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "ExceedingReservesBurnt",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "version",
        internalType: "uint64",
        type: "uint64",
        indexed: false,
      },
    ],
    name: "Initialized",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "previous",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "current",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "MinterChanged",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "previousOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OwnershipTransferred",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      { name: "pubkey", internalType: "bytes", type: "bytes", indexed: true },
      {
        name: "amount",
        internalType: "uint128",
        type: "uint128",
        indexed: false,
      },
    ],
    name: "QueueBoost",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      { name: "pubkey", internalType: "bytes", type: "bytes", indexed: true },
      {
        name: "amount",
        internalType: "uint128",
        type: "uint128",
        indexed: false,
      },
    ],
    name: "QueueDropBoost",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "from", internalType: "address", type: "address", indexed: true },
      {
        name: "receiver",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Redeem",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      { name: "approved", internalType: "bool", type: "bool", indexed: false },
    ],
    name: "SenderWhitelisted",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "previous",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "current",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "StakerChanged",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "from", internalType: "address", type: "address", indexed: true },
      { name: "to", internalType: "address", type: "address", indexed: true },
      {
        name: "value",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Transfer",
  },
  {
    type: "function",
    inputs: [],
    name: "CLOCK_MODE",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "user", internalType: "address", type: "address" },
      { name: "pubkey", internalType: "bytes", type: "bytes" },
    ],
    name: "activateBoost",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "activateBoostDelay",
    outputs: [{ name: "", internalType: "uint32", type: "uint32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "owner", internalType: "address", type: "address" },
      { name: "spender", internalType: "address", type: "address" },
    ],
    name: "allowance",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "spender", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "bgtTermsAndConditions",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "pubkey", internalType: "bytes", type: "bytes" },
    ],
    name: "boosted",
    outputs: [{ name: "", internalType: "uint128", type: "uint128" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "pubkey", internalType: "bytes", type: "bytes" },
    ],
    name: "boostedQueue",
    outputs: [
      { name: "blockNumberLast", internalType: "uint32", type: "uint32" },
      { name: "balance", internalType: "uint128", type: "uint128" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "pubkey", internalType: "bytes", type: "bytes" }],
    name: "boostees",
    outputs: [{ name: "", internalType: "uint128", type: "uint128" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "boosts",
    outputs: [{ name: "", internalType: "uint128", type: "uint128" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "burnExceedingReserves",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "pubkey", internalType: "bytes", type: "bytes" },
      { name: "amount", internalType: "uint128", type: "uint128" },
    ],
    name: "cancelBoost",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "pubkey", internalType: "bytes", type: "bytes" },
      { name: "amount", internalType: "uint128", type: "uint128" },
    ],
    name: "cancelDropBoost",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "pos", internalType: "uint32", type: "uint32" },
    ],
    name: "checkpoints",
    outputs: [
      {
        name: "",
        internalType: "struct Checkpoints.Checkpoint208",
        type: "tuple",
        components: [
          { name: "_key", internalType: "uint48", type: "uint48" },
          { name: "_value", internalType: "uint208", type: "uint208" },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "clock",
    outputs: [{ name: "", internalType: "uint48", type: "uint48" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", internalType: "uint8", type: "uint8" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "delegatee", internalType: "address", type: "address" }],
    name: "delegate",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "delegatee", internalType: "address", type: "address" },
      { name: "nonce", internalType: "uint256", type: "uint256" },
      { name: "expiry", internalType: "uint256", type: "uint256" },
      { name: "v", internalType: "uint8", type: "uint8" },
      { name: "r", internalType: "bytes32", type: "bytes32" },
      { name: "s", internalType: "bytes32", type: "bytes32" },
    ],
    name: "delegateBySig",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "delegates",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "user", internalType: "address", type: "address" },
      { name: "pubkey", internalType: "bytes", type: "bytes" },
    ],
    name: "dropBoost",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "dropBoostDelay",
    outputs: [{ name: "", internalType: "uint32", type: "uint32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "pubkey", internalType: "bytes", type: "bytes" },
    ],
    name: "dropBoostQueue",
    outputs: [
      { name: "blockNumberLast", internalType: "uint32", type: "uint32" },
      { name: "balance", internalType: "uint128", type: "uint128" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "eip712Domain",
    outputs: [
      { name: "fields", internalType: "bytes1", type: "bytes1" },
      { name: "name", internalType: "string", type: "string" },
      { name: "version", internalType: "string", type: "string" },
      { name: "chainId", internalType: "uint256", type: "uint256" },
      { name: "verifyingContract", internalType: "address", type: "address" },
      { name: "salt", internalType: "bytes32", type: "bytes32" },
      { name: "extensions", internalType: "uint256[]", type: "uint256[]" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "timepoint", internalType: "uint256", type: "uint256" }],
    name: "getPastTotalSupply",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "timepoint", internalType: "uint256", type: "uint256" },
    ],
    name: "getPastVotes",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "getVotes",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "_owner", internalType: "address", type: "address" }],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "sender", internalType: "address", type: "address" }],
    name: "isWhitelistedSender",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "distributor", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "minter",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "data", internalType: "bytes[]", type: "bytes[]" }],
    name: "multicall",
    outputs: [{ name: "", internalType: "bytes[]", type: "bytes[]" }],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [],
    name: "name",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "pure",
  },
  {
    type: "function",
    inputs: [{ name: "owner", internalType: "address", type: "address" }],
    name: "nonces",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "pubkey", internalType: "bytes", type: "bytes" }],
    name: "normalizedBoost",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "numCheckpoints",
    outputs: [{ name: "", internalType: "uint32", type: "uint32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "pubkey", internalType: "bytes", type: "bytes" },
      { name: "amount", internalType: "uint128", type: "uint128" },
    ],
    name: "queueBoost",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "pubkey", internalType: "bytes", type: "bytes" },
      { name: "amount", internalType: "uint128", type: "uint128" },
    ],
    name: "queueDropBoost",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "queuedBoost",
    outputs: [{ name: "", internalType: "uint128", type: "uint128" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "receiver", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "redeem",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_activateBoostDelay", internalType: "uint32", type: "uint32" }],
    name: "setActivateBoostDelay",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      {
        name: "_bgtTermsAndConditions",
        internalType: "string",
        type: "string",
      },
    ],
    name: "setBgtTermsAndConditions",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_dropBoostDelay", internalType: "uint32", type: "uint32" }],
    name: "setDropBoostDelay",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_minter", internalType: "address", type: "address" }],
    name: "setMinter",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_staker", internalType: "address", type: "address" }],
    name: "setStaker",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "staker",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "pure",
  },
  {
    type: "function",
    inputs: [],
    name: "totalBoosts",
    outputs: [{ name: "", internalType: "uint128", type: "uint128" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "to", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "transfer",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "from", internalType: "address", type: "address" },
      { name: "to", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "transferFrom",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "unboostedBalanceOf",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "sender", internalType: "address", type: "address" },
      { name: "approved", internalType: "bool", type: "bool" },
    ],
    name: "whitelistSender",
    outputs: [],
    stateMutability: "nonpayable",
  },
] as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const bgtAddress = {
  80094: "0x656b95E550C07a9ffe548bd4085c72418Ceb1dba",
} as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const bgtConfig = { address: bgtAddress, abi: bgtAbi } as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ERC20
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const erc20Abi = [
  {
    type: "event",
    inputs: [
      { name: "owner", type: "address", indexed: true },
      { name: "spender", type: "address", indexed: true },
      { name: "value", type: "uint256", indexed: false },
    ],
    name: "Approval",
  },
  {
    type: "event",
    inputs: [
      { name: "from", type: "address", indexed: true },
      { name: "to", type: "address", indexed: true },
      { name: "value", type: "uint256", indexed: false },
    ],
    name: "Transfer",
  },
  {
    type: "function",
    inputs: [
      { name: "owner", type: "address" },
      { name: "spender", type: "address" },
    ],
    name: "allowance",
    outputs: [{ type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "spender", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "decimals",
    outputs: [{ type: "uint8" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "name",
    outputs: [{ type: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "symbol",
    outputs: [{ type: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    name: "transfer",
    outputs: [{ type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "sender", type: "address" },
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    name: "transferFrom",
    outputs: [{ type: "bool" }],
    stateMutability: "nonpayable",
  },
] as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Exchange
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x1Ab7624d3a07e0D5AC161EEaE45D841c15441c95)
 */
export const exchangeAbi = [
  {
    type: "function",
    inputs: [{ name: "amount", type: "uint256" }],
    name: "exchange",
    outputs: [],
    stateMutability: "nonpayable",
  },
] as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x1Ab7624d3a07e0D5AC161EEaE45D841c15441c95)
 */
export const exchangeAddress = {
  80094: "0x1Ab7624d3a07e0D5AC161EEaE45D841c15441c95",
} as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x1Ab7624d3a07e0D5AC161EEaE45D841c15441c95)
 */
export const exchangeConfig = {
  address: exchangeAddress,
  abi: exchangeAbi,
} as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// FdvReader
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xD5F76a363135A0781295043241f18496dAa31E3d)
 */
export const fdvReaderAbi = [
  {
    type: "function",
    inputs: [
      { name: "sender", internalType: "address", type: "address" },
      { name: "key", internalType: "bytes32", type: "bytes32" },
    ],
    name: "readAsUint64WithTimestamp",
    outputs: [
      { name: "", internalType: "uint64", type: "uint64" },
      { name: "", internalType: "uint64", type: "uint64" },
    ],
    stateMutability: "view",
  },
] as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xD5F76a363135A0781295043241f18496dAa31E3d)
 */
export const fdvReaderAddress = {
  80094: "0xD5F76a363135A0781295043241f18496dAa31E3d",
} as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xD5F76a363135A0781295043241f18496dAa31E3d)
 */
export const fdvReaderConfig = {
  address: fdvReaderAddress,
  abi: fdvReaderAbi,
} as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Gauge
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const gaugeAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "_voter", internalType: "address", type: "address" },
      { name: "_plugin", internalType: "address", type: "address" },
    ],
    stateMutability: "nonpayable",
  },
  { type: "error", inputs: [], name: "Gauge__InvalidZeroInput" },
  { type: "error", inputs: [], name: "Gauge__NotAuthorizedPlugin" },
  { type: "error", inputs: [], name: "Gauge__NotAuthorizedUser" },
  { type: "error", inputs: [], name: "Gauge__NotAuthorizedVoter" },
  { type: "error", inputs: [], name: "Gauge__NotRewardToken" },
  { type: "error", inputs: [], name: "Gauge__RewardTokenAlreadyAdded" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Gauge__Deposited",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "rewardToken",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "Gauge__RewardAdded",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "rewardToken",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "reward",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Gauge__RewardNotified",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      {
        name: "rewardsToken",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "reward",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Gauge__RewardPaid",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Gauge__Withdrawn",
  },
  {
    type: "function",
    inputs: [],
    name: "DURATION",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "_deposit",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "_withdraw",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_rewardsToken", internalType: "address", type: "address" }],
    name: "addReward",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "_rewardsToken", internalType: "address", type: "address" },
    ],
    name: "earned",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "getReward",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_rewardsToken", internalType: "address", type: "address" }],
    name: "getRewardForDuration",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "getRewardTokens",
    outputs: [{ name: "", internalType: "address[]", type: "address[]" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "address", type: "address" }],
    name: "isRewardToken",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "_rewardsToken", internalType: "address", type: "address" }],
    name: "lastTimeRewardApplicable",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "rewardToken", internalType: "address", type: "address" }],
    name: "left",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "_rewardsToken", internalType: "address", type: "address" },
      { name: "reward", internalType: "uint256", type: "uint256" },
    ],
    name: "notifyRewardAmount",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "plugin",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "address", type: "address" }],
    name: "rewardData",
    outputs: [
      { name: "periodFinish", internalType: "uint256", type: "uint256" },
      { name: "rewardRate", internalType: "uint256", type: "uint256" },
      { name: "lastUpdateTime", internalType: "uint256", type: "uint256" },
      {
        name: "rewardPerTokenStored",
        internalType: "uint256",
        type: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "_rewardsToken", internalType: "address", type: "address" }],
    name: "rewardPerToken",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    name: "rewardTokens",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "address", type: "address" },
    ],
    name: "rewards",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "address", type: "address" },
    ],
    name: "userRewardPerTokenPaid",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "voter",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
] as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Henlo
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const henloAbi = [
  {
    type: "event",
    inputs: [
      { name: "owner", type: "address", indexed: true },
      { name: "spender", type: "address", indexed: true },
      { name: "value", type: "uint256", indexed: false },
    ],
    name: "Approval",
  },
  {
    type: "event",
    inputs: [
      { name: "from", type: "address", indexed: true },
      { name: "to", type: "address", indexed: true },
      { name: "value", type: "uint256", indexed: false },
    ],
    name: "Transfer",
  },
  {
    type: "function",
    inputs: [
      { name: "owner", type: "address" },
      { name: "spender", type: "address" },
    ],
    name: "allowance",
    outputs: [{ type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "spender", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "decimals",
    outputs: [{ type: "uint8" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "name",
    outputs: [{ type: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "symbol",
    outputs: [{ type: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    name: "transfer",
    outputs: [{ type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "sender", type: "address" },
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    name: "transferFrom",
    outputs: [{ type: "bool" }],
    stateMutability: "nonpayable",
  },
] as const;

/**
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const henloAddress = {
  80069: "0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be",
  80094: "0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5",
} as const;

/**
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const henloConfig = { address: henloAddress, abi: henloAbi } as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HenloCards
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const henloCardsAbi = [
  {
    type: "constructor",
    inputs: [{ name: "_owner", internalType: "address", type: "address" }],
    stateMutability: "nonpayable",
  },
  { type: "error", inputs: [], name: "AccountBalanceOverflow" },
  { type: "error", inputs: [], name: "AlreadyInitialized" },
  { type: "error", inputs: [], name: "AlreadyMinted" },
  { type: "error", inputs: [], name: "BalanceQueryForZeroAddress" },
  { type: "error", inputs: [], name: "InsufficientFunds" },
  { type: "error", inputs: [], name: "NewOwnerIsZeroAddress" },
  { type: "error", inputs: [], name: "NoHandoverRequest" },
  { type: "error", inputs: [], name: "NotOwnerNorApproved" },
  { type: "error", inputs: [], name: "NotTransferable" },
  { type: "error", inputs: [], name: "TokenAlreadyExists" },
  { type: "error", inputs: [], name: "TokenDoesNotExist" },
  { type: "error", inputs: [], name: "TransferFromIncorrectOwner" },
  { type: "error", inputs: [], name: "TransferToNonERC721ReceiverImplementer" },
  { type: "error", inputs: [], name: "TransferToZeroAddress" },
  { type: "error", inputs: [], name: "Unauthorized" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      { name: "id", internalType: "uint256", type: "uint256", indexed: true },
    ],
    name: "Approval",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "operator",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "isApproved",
        internalType: "bool",
        type: "bool",
        indexed: false,
      },
    ],
    name: "ApprovalForAll",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "pendingOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OwnershipHandoverCanceled",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "pendingOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OwnershipHandoverRequested",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "oldOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OwnershipTransferred",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "from", internalType: "address", type: "address", indexed: true },
      { name: "to", internalType: "address", type: "address", indexed: true },
      { name: "id", internalType: "uint256", type: "uint256", indexed: true },
    ],
    name: "Transfer",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "id", internalType: "uint256", type: "uint256" },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [{ name: "owner", internalType: "address", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "result", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "cancelOwnershipHandover",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [{ name: "pendingOwner", internalType: "address", type: "address" }],
    name: "completeOwnershipHandover",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [{ name: "id", internalType: "uint256", type: "uint256" }],
    name: "getApproved",
    outputs: [{ name: "result", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "owner", internalType: "address", type: "address" },
      { name: "operator", internalType: "address", type: "address" },
    ],
    name: "isApprovedForAll",
    outputs: [{ name: "result", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [],
    name: "name",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "pure",
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "result", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "id", internalType: "uint256", type: "uint256" }],
    name: "ownerOf",
    outputs: [{ name: "result", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "pendingOwner", internalType: "address", type: "address" }],
    name: "ownershipHandoverExpiresAt",
    outputs: [{ name: "result", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "price",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [],
    name: "requestOwnershipHandover",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [
      { name: "from", internalType: "address", type: "address" },
      { name: "to", internalType: "address", type: "address" },
      { name: "id", internalType: "uint256", type: "uint256" },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [
      { name: "from", internalType: "address", type: "address" },
      { name: "to", internalType: "address", type: "address" },
      { name: "id", internalType: "uint256", type: "uint256" },
      { name: "data", internalType: "bytes", type: "bytes" },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [
      { name: "operator", internalType: "address", type: "address" },
      { name: "isApproved", internalType: "bool", type: "bool" },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_baseURI", internalType: "string", type: "string" }],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_price", internalType: "uint256", type: "uint256" }],
    name: "setPrice",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "interfaceId", internalType: "bytes4", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ name: "result", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "pure",
  },
  {
    type: "function",
    inputs: [{ name: "_id", internalType: "uint256", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "from", internalType: "address", type: "address" },
      { name: "to", internalType: "address", type: "address" },
      { name: "id", internalType: "uint256", type: "uint256" },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [{ name: "_to", internalType: "address", type: "address" }],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
  },
] as const;

/**
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const henloCardsAddress = {
  80084: "0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC",
} as const;

/**
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const henloCardsConfig = {
  address: henloCardsAddress,
  abi: henloCardsAbi,
} as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HenloOptions
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const henloOptionsAbi = [
  {
    type: "constructor",
    inputs: [{ name: "_henlo", internalType: "address", type: "address" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [{ name: "result", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "owner", internalType: "address", type: "address" },
      { name: "spender", internalType: "address", type: "address" },
    ],
    name: "allowance",
    outputs: [{ name: "result", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "spender", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "owner", internalType: "address", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "result", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "cancelOwnershipHandover",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [
      { name: "_index", internalType: "uint256", type: "uint256" },
      { name: "_amount", internalType: "uint256", type: "uint256" },
      { name: "_proof", internalType: "bytes32[]", type: "bytes32[]" },
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_index", internalType: "uint256", type: "uint256" }],
    name: "claimed",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "pendingOwner", internalType: "address", type: "address" }],
    name: "completeOwnershipHandover",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", internalType: "uint8", type: "uint8" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "_amount", internalType: "uint256", type: "uint256" }],
    name: "exercise",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [],
    name: "expiresAt",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "_price", internalType: "uint256", type: "uint256" }],
    name: "launch",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "name",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "pure",
  },
  {
    type: "function",
    inputs: [{ name: "owner", internalType: "address", type: "address" }],
    name: "nonces",
    outputs: [{ name: "result", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "result", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "pendingOwner", internalType: "address", type: "address" }],
    name: "ownershipHandoverExpiresAt",
    outputs: [{ name: "result", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "owner", internalType: "address", type: "address" },
      { name: "spender", internalType: "address", type: "address" },
      { name: "value", internalType: "uint256", type: "uint256" },
      { name: "deadline", internalType: "uint256", type: "uint256" },
      { name: "v", internalType: "uint8", type: "uint8" },
      { name: "r", internalType: "bytes32", type: "bytes32" },
      { name: "s", internalType: "bytes32", type: "bytes32" },
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "pricePerHenlo",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [],
    name: "requestOwnershipHandover",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [{ name: "_expiresAt", internalType: "uint256", type: "uint256" }],
    name: "setExpiresAt",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_merkleRoot", internalType: "bytes32", type: "bytes32" }],
    name: "setMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "pure",
  },
  {
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "result", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "to", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "transfer",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "from", internalType: "address", type: "address" },
      { name: "to", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "transferFrom",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [{ name: "_to", internalType: "address", type: "address" }],
    name: "withdrawBERA",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_to", internalType: "address", type: "address" }],
    name: "withdrawHenlo",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "spender",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Approval",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "pendingOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OwnershipHandoverCanceled",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "pendingOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OwnershipHandoverRequested",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "oldOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OwnershipTransferred",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "from", internalType: "address", type: "address", indexed: true },
      { name: "to", internalType: "address", type: "address", indexed: true },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Transfer",
  },
  { type: "error", inputs: [], name: "AllowanceOverflow" },
  { type: "error", inputs: [], name: "AllowanceUnderflow" },
  { type: "error", inputs: [], name: "AlreadyClaimed" },
  { type: "error", inputs: [], name: "AlreadyInitialized" },
  { type: "error", inputs: [], name: "CannotExerciseYet" },
  { type: "error", inputs: [], name: "CannotTransfer" },
  { type: "error", inputs: [], name: "Expired" },
  { type: "error", inputs: [], name: "InsufficientAllowance" },
  { type: "error", inputs: [], name: "InsufficientBalance" },
  { type: "error", inputs: [], name: "InsufficientFunds" },
  { type: "error", inputs: [], name: "InvalidPermit" },
  { type: "error", inputs: [], name: "InvalidProof" },
  { type: "error", inputs: [], name: "InvalidRoot" },
  { type: "error", inputs: [], name: "NewOwnerIsZeroAddress" },
  { type: "error", inputs: [], name: "NoHandoverRequest" },
  { type: "error", inputs: [], name: "PermitExpired" },
  { type: "error", inputs: [], name: "TotalSupplyOverflow" },
  { type: "error", inputs: [], name: "Unauthorized" },
] as const;

/**
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const henloOptionsAddress = {
  11155111: "0x01658783645a0c6cC0e658669486d4e98f0f8865",
} as const;

/**
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const henloOptionsConfig = {
  address: henloOptionsAddress,
  abi: henloOptionsAbi,
} as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HenloPFP
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const henloPfpAbi = [
  {
    type: "constructor",
    inputs: [{ name: "_owner", internalType: "address", type: "address" }],
    stateMutability: "nonpayable",
  },
  { type: "error", inputs: [], name: "AccountBalanceOverflow" },
  { type: "error", inputs: [], name: "AlreadyInitialized" },
  { type: "error", inputs: [], name: "AlreadyMinted" },
  { type: "error", inputs: [], name: "ArrayLengthsMismatch" },
  { type: "error", inputs: [], name: "InsufficientBalance" },
  { type: "error", inputs: [], name: "InsufficientFunds" },
  { type: "error", inputs: [], name: "MaxSupplyReached" },
  { type: "error", inputs: [], name: "NewOwnerIsZeroAddress" },
  { type: "error", inputs: [], name: "NoHandoverRequest" },
  { type: "error", inputs: [], name: "NotOwnerNorApproved" },
  { type: "error", inputs: [], name: "NotTransferable" },
  {
    type: "error",
    inputs: [],
    name: "TransferToNonERC1155ReceiverImplementer",
  },
  { type: "error", inputs: [], name: "TransferToZeroAddress" },
  { type: "error", inputs: [], name: "Unauthorized" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "operator",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "isApproved",
        internalType: "bool",
        type: "bool",
        indexed: false,
      },
    ],
    name: "ApprovalForAll",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "pendingOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OwnershipHandoverCanceled",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "pendingOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OwnershipHandoverRequested",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "oldOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OwnershipTransferred",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "operator",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      { name: "from", internalType: "address", type: "address", indexed: true },
      { name: "to", internalType: "address", type: "address", indexed: true },
      {
        name: "ids",
        internalType: "uint256[]",
        type: "uint256[]",
        indexed: false,
      },
      {
        name: "amounts",
        internalType: "uint256[]",
        type: "uint256[]",
        indexed: false,
      },
    ],
    name: "TransferBatch",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "operator",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      { name: "from", internalType: "address", type: "address", indexed: true },
      { name: "to", internalType: "address", type: "address", indexed: true },
      { name: "id", internalType: "uint256", type: "uint256", indexed: false },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "TransferSingle",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "value", internalType: "string", type: "string", indexed: false },
      { name: "id", internalType: "uint256", type: "uint256", indexed: true },
    ],
    name: "URI",
  },
  {
    type: "function",
    inputs: [
      { name: "owner", internalType: "address", type: "address" },
      { name: "id", internalType: "uint256", type: "uint256" },
    ],
    name: "balanceOf",
    outputs: [{ name: "result", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "owners", internalType: "address[]", type: "address[]" },
      { name: "ids", internalType: "uint256[]", type: "uint256[]" },
    ],
    name: "balanceOfBatch",
    outputs: [{ name: "balances", internalType: "uint256[]", type: "uint256[]" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "cancelOwnershipHandover",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [{ name: "pendingOwner", internalType: "address", type: "address" }],
    name: "completeOwnershipHandover",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [
      { name: "owner", internalType: "address", type: "address" },
      { name: "operator", internalType: "address", type: "address" },
    ],
    name: "isApprovedForAll",
    outputs: [{ name: "result", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "maxSupply",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "_id", internalType: "uint256", type: "uint256" }],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [],
    name: "name",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "pure",
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "result", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "pendingOwner", internalType: "address", type: "address" }],
    name: "ownershipHandoverExpiresAt",
    outputs: [{ name: "result", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "price",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [],
    name: "requestOwnershipHandover",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [
      { name: "from", internalType: "address", type: "address" },
      { name: "to", internalType: "address", type: "address" },
      { name: "ids", internalType: "uint256[]", type: "uint256[]" },
      { name: "amounts", internalType: "uint256[]", type: "uint256[]" },
      { name: "data", internalType: "bytes", type: "bytes" },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "from", internalType: "address", type: "address" },
      { name: "to", internalType: "address", type: "address" },
      { name: "id", internalType: "uint256", type: "uint256" },
      { name: "amount", internalType: "uint256", type: "uint256" },
      { name: "data", internalType: "bytes", type: "bytes" },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "operator", internalType: "address", type: "address" },
      { name: "isApproved", internalType: "bool", type: "bool" },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_baseURI", internalType: "string", type: "string" }],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_maxSupply", internalType: "uint256", type: "uint256" }],
    name: "setMaxSupply",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_price", internalType: "uint256", type: "uint256" }],
    name: "setPrice",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "interfaceId", internalType: "bytes4", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ name: "result", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "pure",
  },
  {
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "payable",
  },
  {
    type: "function",
    inputs: [{ name: "_id", internalType: "uint256", type: "uint256" }],
    name: "uri",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "_to", internalType: "address", type: "address" }],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
  },
] as const;

/**
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const henloPfpAddress = {
  80084: "0x0982c808B42A72d256d7E9d3BdF61e44ef31230d",
} as const;

/**
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const henloPfpConfig = {
  address: henloPfpAddress,
  abi: henloPfpAbi,
} as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// HenloVault
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const henloVaultAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "asset_", internalType: "address", type: "address" },
      { name: "oracle_", internalType: "address", type: "address" },
      { name: "treasury_", internalType: "address", type: "address" },
      { name: "oracleSender_", internalType: "address", type: "address" },
      { name: "oracleKey_", internalType: "bytes32", type: "bytes32" },
    ],
    stateMutability: "nonpayable",
  },
  { type: "error", inputs: [], name: "AlreadyDeployed" },
  { type: "error", inputs: [], name: "AmountExceedsDepositLimit" },
  { type: "error", inputs: [], name: "CannotRedeemAtThisTime" },
  { type: "error", inputs: [], name: "DepositsAlreadyPaused" },
  { type: "error", inputs: [], name: "DepositsArePaused" },
  { type: "error", inputs: [], name: "DepositsNotPaused" },
  { type: "error", inputs: [], name: "EnforcedPause" },
  { type: "error", inputs: [], name: "ExpectedPause" },
  { type: "error", inputs: [], name: "InsufficientHenlockedBalance" },
  { type: "error", inputs: [], name: "InvalidDepositLimit" },
  { type: "error", inputs: [], name: "InvalidEpochStrike" },
  { type: "error", inputs: [], name: "MaxFeeExceeded" },
  { type: "error", inputs: [], name: "NewLimitTooLow" },
  {
    type: "error",
    inputs: [{ name: "owner", internalType: "address", type: "address" }],
    name: "OwnableInvalidOwner",
  },
  {
    type: "error",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "OwnableUnauthorizedAccount",
  },
  { type: "error", inputs: [], name: "ReentrancyGuardReentrantCall" },
  { type: "error", inputs: [], name: "RoundAlreadyExistsOrNotClosed" },
  { type: "error", inputs: [], name: "RoundIsClosed" },
  { type: "error", inputs: [], name: "RoundNotOpened" },
  {
    type: "error",
    inputs: [{ name: "token", internalType: "address", type: "address" }],
    name: "SafeERC20FailedOperation",
  },
  { type: "error", inputs: [], name: "StaleOracleData" },
  { type: "error", inputs: [], name: "StrikeTooLow" },
  { type: "error", inputs: [], name: "ZeroAddress" },
  { type: "error", inputs: [], name: "ZeroMint" },
  { type: "error", inputs: [], name: "ZeroOracleAddress" },
  { type: "error", inputs: [], name: "ZeroOracleSenderAddress" },
  { type: "error", inputs: [], name: "ZeroRedeemAmount" },
  { type: "error", inputs: [], name: "ZeroTreasuryAddress" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "strike", internalType: "uint64", type: "uint64", indexed: true },
      {
        name: "token",
        internalType: "address",
        type: "address",
        indexed: false,
      },
    ],
    name: "DeployERC20",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "epochId",
        internalType: "uint48",
        type: "uint48",
        indexed: true,
      },
      { name: "strike", internalType: "uint64", type: "uint64", indexed: true },
      {
        name: "newDepositLimit",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "DepositLimitUpdated",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "epochId",
        internalType: "uint48",
        type: "uint48",
        indexed: true,
      },
      { name: "strike", internalType: "uint64", type: "uint64", indexed: true },
    ],
    name: "DepositsPaused",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "epochId",
        internalType: "uint48",
        type: "uint48",
        indexed: true,
      },
      { name: "strike", internalType: "uint64", type: "uint64", indexed: true },
    ],
    name: "DepositsUnpaused",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      {
        name: "strike",
        internalType: "uint256",
        type: "uint256",
        indexed: true,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Mint",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "reservoir",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      { name: "strike", internalType: "uint64", type: "uint64", indexed: true },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "MintFromReservoir",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "newKey",
        internalType: "bytes32",
        type: "bytes32",
        indexed: true,
      },
    ],
    name: "OracleKeyUpdated",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "newSender",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OracleSenderUpdated",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "newOracle",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OracleUpdated",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "previousOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OwnershipTransferred",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: false,
      },
    ],
    name: "Paused",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      { name: "strike", internalType: "uint64", type: "uint64", indexed: true },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Redeem",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "epochId",
        internalType: "uint48",
        type: "uint48",
        indexed: true,
      },
      { name: "strike", internalType: "uint64", type: "uint64", indexed: true },
    ],
    name: "RoundClosed",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "epochId",
        internalType: "uint48",
        type: "uint48",
        indexed: true,
      },
      { name: "strike", internalType: "uint64", type: "uint64", indexed: true },
      {
        name: "depositLimit",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "RoundOpened",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [{ name: "fee", internalType: "uint256", type: "uint256", indexed: false }],
    name: "SetFee",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "treasury",
        internalType: "address",
        type: "address",
        indexed: false,
      },
    ],
    name: "SetTreasury",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: false,
      },
    ],
    name: "Unpaused",
  },
  {
    type: "function",
    inputs: [],
    name: "FEE_BASIS",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "MAX_FEE",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "asset",
    outputs: [{ name: "", internalType: "contract IERC20", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "strike", internalType: "uint64", type: "uint64" }],
    name: "canRedeem",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "strike", internalType: "uint64", type: "uint64" }],
    name: "deployERC20",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "strike", internalType: "uint64", type: "uint64" }],
    name: "deployments",
    outputs: [{ name: "token", internalType: "contract IERC20", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "strike", internalType: "uint64", type: "uint64" }],
    name: "epochs",
    outputs: [{ name: "epochId", internalType: "uint48", type: "uint48" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "fee",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "getOracleKey",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "strike", internalType: "uint64", type: "uint64" }],
    name: "getRoundInfo",
    outputs: [
      { name: "exists", internalType: "bool", type: "bool" },
      { name: "closed", internalType: "bool", type: "bool" },
      { name: "depositsPaused", internalType: "bool", type: "bool" },
      { name: "timestamp", internalType: "uint256", type: "uint256" },
      { name: "depositLimit", internalType: "uint256", type: "uint256" },
      { name: "totalDeposits", internalType: "uint256", type: "uint256" },
      { name: "remainingCapacity", internalType: "uint256", type: "uint256" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "hodlMulti",
    outputs: [{ name: "", internalType: "contract henlocked", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "epochId", internalType: "uint48", type: "uint48" }],
    name: "infos",
    outputs: [
      { name: "strike", internalType: "uint64", type: "uint64" },
      { name: "closed", internalType: "bool", type: "bool" },
      { name: "depositsPaused", internalType: "bool", type: "bool" },
      { name: "timestamp", internalType: "uint256", type: "uint256" },
      { name: "depositLimit", internalType: "uint256", type: "uint256" },
      { name: "totalDeposits", internalType: "uint256", type: "uint256" },
      { name: "reservoir", internalType: "address", type: "address" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "strike", internalType: "uint64", type: "uint64" },
      { name: "amount", internalType: "uint256", type: "uint256" },
      { name: "minimumWhaleMatch", internalType: "uint256", type: "uint256" },
    ],
    name: "mint",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "nextId",
    outputs: [{ name: "", internalType: "uint48", type: "uint48" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "strike", internalType: "uint64", type: "uint64" },
      { name: "depositLimit", internalType: "uint256", type: "uint256" },
      { name: "reservoir", internalType: "address", type: "address" },
    ],
    name: "openRound",
    outputs: [{ name: "", internalType: "uint48", type: "uint48" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "oracle",
    outputs: [{ name: "", internalType: "contract IOracleChainsight", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "oracleSender",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "strike", internalType: "uint64", type: "uint64" }],
    name: "pauseDeposits",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "paused",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "value", internalType: "uint256", type: "uint256" }],
    name: "previewMint",
    outputs: [
      { name: "depositAfterFee", internalType: "uint256", type: "uint256" },
      { name: "feeAmount", internalType: "uint256", type: "uint256" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "strike", internalType: "uint64", type: "uint64" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "redeem",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "fee_", internalType: "uint256", type: "uint256" }],
    name: "setFee",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "newOracle", internalType: "address", type: "address" }],
    name: "setOracle",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "newKey", internalType: "bytes32", type: "bytes32" }],
    name: "setOracleKey",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "newSender", internalType: "address", type: "address" }],
    name: "setOracleSender",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "treasury_", internalType: "address", type: "address" }],
    name: "setTreasury",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "treasury",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "strike", internalType: "uint64", type: "uint64" }],
    name: "unpauseDeposits",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "strike", internalType: "uint64", type: "uint64" },
      { name: "newDepositLimit", internalType: "uint256", type: "uint256" },
    ],
    name: "updateDepositLimit",
    outputs: [],
    stateMutability: "nonpayable",
  },
] as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const henloVaultAddress = {
  80094: "0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC",
} as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const henloVaultConfig = {
  address: henloVaultAddress,
  abi: henloVaultAbi,
} as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// IchiVault
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xcb42b9d09d8da230d0390728c6f236511fac403b)
 */
export const ichiVaultAbi = [
  {
    type: "function",
    inputs: [],
    name: "getReserves",
    outputs: [
      { name: "_reserve0", internalType: "uint112", type: "uint112" },
      { name: "_reserve1", internalType: "uint112", type: "uint112" },
      { name: "_blockTimestampLast", internalType: "uint32", type: "uint32" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "token0",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "token1",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
] as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xcb42b9d09d8da230d0390728c6f236511fac403b)
 */
export const ichiVaultAddress = {
  80094: "0xCB42b9D09d8Da230d0390728C6F236511FaC403b",
} as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xcb42b9d09d8da230d0390728c6f236511fac403b)
 */
export const ichiVaultConfig = {
  address: ichiVaultAddress,
  abi: ichiVaultAbi,
} as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// RamenHenlo
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const ramenHenloAbi = [
  {
    type: "event",
    inputs: [
      { name: "owner", type: "address", indexed: true },
      { name: "spender", type: "address", indexed: true },
      { name: "value", type: "uint256", indexed: false },
    ],
    name: "Approval",
  },
  {
    type: "event",
    inputs: [
      { name: "from", type: "address", indexed: true },
      { name: "to", type: "address", indexed: true },
      { name: "value", type: "uint256", indexed: false },
    ],
    name: "Transfer",
  },
  {
    type: "function",
    inputs: [
      { name: "owner", type: "address" },
      { name: "spender", type: "address" },
    ],
    name: "allowance",
    outputs: [{ type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "spender", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    name: "approve",
    outputs: [{ type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "decimals",
    outputs: [{ type: "uint8" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "name",
    outputs: [{ type: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "symbol",
    outputs: [{ type: "string" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    name: "transfer",
    outputs: [{ type: "bool" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "sender", type: "address" },
      { name: "recipient", type: "address" },
      { name: "amount", type: "uint256" },
    ],
    name: "transferFrom",
    outputs: [{ type: "bool" }],
    stateMutability: "nonpayable",
  },
] as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const ramenHenloAddress = {
  80094: "0x371b36BCD10F6801ebbc578Af897624cc4130146",
} as const;

/**
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const ramenHenloConfig = {
  address: ramenHenloAddress,
  abi: ramenHenloAbi,
} as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Reservoir
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const reservoirAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "_plHENLO", internalType: "address", type: "address" },
      { name: "_HENLO", internalType: "address", type: "address" },
      { name: "_vault", internalType: "address", type: "address" },
      { name: "_owner", internalType: "address", type: "address" },
      { name: "_strike", internalType: "uint64", type: "uint64" },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "error",
    inputs: [{ name: "owner", internalType: "address", type: "address" }],
    name: "OwnableInvalidOwner",
  },
  {
    type: "error",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "OwnableUnauthorizedAccount",
  },
  {
    type: "error",
    inputs: [{ name: "token", internalType: "address", type: "address" }],
    name: "SafeERC20FailedOperation",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [{ name: "who", internalType: "address", type: "address", indexed: false }],
    name: "AddedToWhiteList",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "startTime",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "endTime",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "length",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "CampaginStarted",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: true,
      },
    ],
    name: "MatchedAmountIncremented",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "previousOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "OwnershipTransferred",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [{ name: "who", internalType: "address", type: "address", indexed: false }],
    name: "RemovedFromWhitelist",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "who", internalType: "address", type: "address", indexed: true },
      {
        name: "plHENLOAmount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "HENLOAmount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "WhitelistClaim",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "who", internalType: "address", type: "address", indexed: true },
      {
        name: "HENLOAmount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "WhitelistDeposit",
  },
  {
    type: "function",
    inputs: [],
    name: "HENLO",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "_who", internalType: "address", type: "address" }],
    name: "addWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "claimWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_amount", internalType: "uint256", type: "uint256" }],
    name: "depositWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "endTime",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "amount", internalType: "uint256", type: "uint256" }],
    name: "incrementMatched",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "amount", internalType: "uint256", type: "uint256" }],
    name: "matchMint",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "uint256[]", type: "uint256[]" },
      { name: "", internalType: "uint256[]", type: "uint256[]" },
      { name: "", internalType: "bytes", type: "bytes" },
    ],
    name: "onERC1155BatchReceived",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "uint256", type: "uint256" },
      { name: "", internalType: "uint256", type: "uint256" },
      { name: "", internalType: "bytes", type: "bytes" },
    ],
    name: "onERC1155Received",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "plHENLO",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "plHENLOPerHENLO",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "_who", internalType: "address", type: "address" }],
    name: "removeWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "settle",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "settled",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "_length", internalType: "uint256", type: "uint256" }],
    name: "startCampagin",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "startTime",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "started",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "strike",
    outputs: [{ name: "", internalType: "uint64", type: "uint64" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "interfaceId", internalType: "bytes4", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "totalMatched",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "totalWhitelistDeposit",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "vault",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "who", internalType: "address", type: "address" }],
    name: "whitelistDeposit",
    outputs: [{ name: "amount", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "who", internalType: "address", type: "address" }],
    name: "whitelisted",
    outputs: [{ name: "whitelist", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
] as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// RewardVault
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const rewardVaultAbi = [
  { type: "constructor", inputs: [], stateMutability: "nonpayable" },
  { type: "error", inputs: [], name: "AmountGreaterThanReward" },
  { type: "error", inputs: [], name: "AmountLessThanMinIncentiveRate" },
  { type: "error", inputs: [], name: "CannotRecoverIncentiveToken" },
  { type: "error", inputs: [], name: "CannotRecoverRewardToken" },
  { type: "error", inputs: [], name: "CannotRecoverStakingToken" },
  { type: "error", inputs: [], name: "CommissionChangeAlreadyQueued" },
  { type: "error", inputs: [], name: "CommissionNotQueuedOrDelayNotPassed" },
  { type: "error", inputs: [], name: "DepositNotMultipleOfGwei" },
  { type: "error", inputs: [], name: "DepositValueTooHigh" },
  { type: "error", inputs: [], name: "DonateAmountLessThanPayoutAmount" },
  {
    type: "error",
    inputs: [{ name: "receiver", internalType: "address", type: "address" }],
    name: "DuplicateReceiver",
  },
  { type: "error", inputs: [], name: "DurationChangeNotAllowed" },
  { type: "error", inputs: [], name: "EnforcedPause" },
  { type: "error", inputs: [], name: "ExpectedPause" },
  { type: "error", inputs: [], name: "IncentiveRateTooHigh" },
  { type: "error", inputs: [], name: "IndexOutOfRange" },
  { type: "error", inputs: [], name: "InsolventReward" },
  { type: "error", inputs: [], name: "InsufficientDelegateStake" },
  { type: "error", inputs: [], name: "InsufficientDeposit" },
  { type: "error", inputs: [], name: "InsufficientIncentiveTokens" },
  { type: "error", inputs: [], name: "InsufficientNativeValue" },
  { type: "error", inputs: [], name: "InsufficientSelfStake" },
  { type: "error", inputs: [], name: "InsufficientStake" },
  { type: "error", inputs: [], name: "InvalidActivateBoostDelay" },
  { type: "error", inputs: [], name: "InvalidArray" },
  { type: "error", inputs: [], name: "InvalidBaseRate" },
  { type: "error", inputs: [], name: "InvalidBoostMultiplier" },
  { type: "error", inputs: [], name: "InvalidCommissionChangeDelay" },
  { type: "error", inputs: [], name: "InvalidCommissionValue" },
  { type: "error", inputs: [], name: "InvalidCredentialsLength" },
  { type: "error", inputs: [], name: "InvalidDistribution" },
  { type: "error", inputs: [], name: "InvalidDropBoostDelay" },
  { type: "error", inputs: [], name: "InvalidIncentiveFeeRate" },
  { type: "error", inputs: [], name: "InvalidIncentiveRate" },
  { type: "error", inputs: [], name: "InvalidInitialization" },
  { type: "error", inputs: [], name: "InvalidMaxIncentiveTokensCount" },
  { type: "error", inputs: [], name: "InvalidMaxWeightPerVault" },
  { type: "error", inputs: [], name: "InvalidMerkleRoot" },
  { type: "error", inputs: [], name: "InvalidMinBoostedRewardRate" },
  { type: "error", inputs: [], name: "InvalidProof" },
  { type: "error", inputs: [], name: "InvalidPubKeyLength" },
  { type: "error", inputs: [], name: "InvalidRewardAllocationWeights" },
  { type: "error", inputs: [], name: "InvalidRewardClaimDelay" },
  { type: "error", inputs: [], name: "InvalidRewardConvexity" },
  { type: "error", inputs: [], name: "InvalidRewardDuration" },
  { type: "error", inputs: [], name: "InvalidRewardRate" },
  { type: "error", inputs: [], name: "InvalidSignatureLength" },
  { type: "error", inputs: [], name: "InvalidStartBlock" },
  { type: "error", inputs: [], name: "InvalidToken" },
  { type: "error", inputs: [], name: "InvalidWeight" },
  { type: "error", inputs: [], name: "InvalidateDefaultRewardAllocation" },
  { type: "error", inputs: [], name: "InvariantCheckFailed" },
  { type: "error", inputs: [], name: "MaxNumWeightsPerRewardAllocationIsZero" },
  { type: "error", inputs: [], name: "MinIncentiveRateIsZero" },
  { type: "error", inputs: [], name: "NotAContract" },
  { type: "error", inputs: [], name: "NotApprovedSender" },
  { type: "error", inputs: [], name: "NotBGT" },
  { type: "error", inputs: [], name: "NotBlockRewardController" },
  { type: "error", inputs: [], name: "NotDelegate" },
  { type: "error", inputs: [], name: "NotDistributor" },
  { type: "error", inputs: [], name: "NotEnoughBalance" },
  { type: "error", inputs: [], name: "NotEnoughBoostedBalance" },
  { type: "error", inputs: [], name: "NotEnoughTime" },
  { type: "error", inputs: [], name: "NotFactoryVault" },
  { type: "error", inputs: [], name: "NotFeeCollector" },
  { type: "error", inputs: [], name: "NotIncentiveManager" },
  { type: "error", inputs: [], name: "NotInitializing" },
  { type: "error", inputs: [], name: "NotNewOperator" },
  { type: "error", inputs: [], name: "NotOperator" },
  { type: "error", inputs: [], name: "NotRewardDurationManager" },
  { type: "error", inputs: [], name: "NotRewardVaultManager" },
  { type: "error", inputs: [], name: "NotWhitelistedVault" },
  { type: "error", inputs: [], name: "OperatorAlreadySet" },
  {
    type: "error",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "OwnableUnauthorizedAccount",
  },
  { type: "error", inputs: [], name: "PayoutAmountIsZero" },
  { type: "error", inputs: [], name: "ReentrancyGuardReentrantCall" },
  { type: "error", inputs: [], name: "RewardAllocationAlreadyQueued" },
  { type: "error", inputs: [], name: "RewardAllocationBlockDelayTooLarge" },
  { type: "error", inputs: [], name: "RewardCycleNotEnded" },
  { type: "error", inputs: [], name: "RewardDurationCoolDownPeriodNotPassed" },
  { type: "error", inputs: [], name: "RewardInactive" },
  { type: "error", inputs: [], name: "RewardsDurationIsZero" },
  {
    type: "error",
    inputs: [{ name: "token", internalType: "address", type: "address" }],
    name: "SafeERC20FailedOperation",
  },
  { type: "error", inputs: [], name: "StakeAmountIsZero" },
  { type: "error", inputs: [], name: "TimestampAlreadyProcessed" },
  { type: "error", inputs: [], name: "TokenAlreadyWhitelistedOrLimitReached" },
  { type: "error", inputs: [], name: "TokenNotWhitelisted" },
  { type: "error", inputs: [], name: "TooManyWeights" },
  { type: "error", inputs: [], name: "TotalSupplyOverflow" },
  { type: "error", inputs: [], name: "UnauthorizedETHTransfer" },
  { type: "error", inputs: [], name: "WithdrawAmountIsZero" },
  { type: "error", inputs: [], name: "WithdrawalAlreadyRequested" },
  { type: "error", inputs: [], name: "WithdrawalNotReady" },
  { type: "error", inputs: [], name: "WithdrawalNotRequested" },
  { type: "error", inputs: [], name: "ZeroAddress" },
  { type: "error", inputs: [], name: "ZeroOperatorOnFirstDeposit" },
  { type: "error", inputs: [], name: "ZeroPercentageWeight" },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "pubkey", internalType: "bytes", type: "bytes", indexed: true },
      {
        name: "token",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "bgtEmitted",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "BGTBoosterIncentivesProcessFailed",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "pubkey", internalType: "bytes", type: "bytes", indexed: true },
      {
        name: "token",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "bgtEmitted",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "BGTBoosterIncentivesProcessed",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "delegate",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "DelegateStaked",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "delegate",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "DelegateWithdrawn",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "distributor",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "DistributorSet",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "token",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: false,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "incentiveRate",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "IncentiveAdded",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "token",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "IncentiveFeeCollected",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "token",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "IncentiveFeeCollectionFailed",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "token",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "newManager",
        internalType: "address",
        type: "address",
        indexed: false,
      },
      {
        name: "oldManager",
        internalType: "address",
        type: "address",
        indexed: false,
      },
    ],
    name: "IncentiveManagerChanged",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "token",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "IncentiveTokenRemoved",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "token",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "minIncentiveRate",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "manager",
        internalType: "address",
        type: "address",
        indexed: false,
      },
    ],
    name: "IncentiveTokenWhitelisted",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "pubkey", internalType: "bytes", type: "bytes", indexed: true },
      {
        name: "token",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "bgtEmitted",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "IncentivesProcessFailed",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "pubkey", internalType: "bytes", type: "bytes", indexed: true },
      {
        name: "token",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "bgtEmitted",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "IncentivesProcessed",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "version",
        internalType: "uint64",
        type: "uint64",
        indexed: false,
      },
    ],
    name: "Initialized",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "maxIncentiveTokensCount",
        internalType: "uint8",
        type: "uint8",
        indexed: false,
      },
    ],
    name: "MaxIncentiveTokensCountUpdated",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "newMinRewardDurationForTargetRate",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "oldMinRewardDurationForTargetRate",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "MinRewardDurationForTargetRateUpdated",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: false,
      },
      {
        name: "operator",
        internalType: "address",
        type: "address",
        indexed: false,
      },
    ],
    name: "OperatorSet",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: false,
      },
    ],
    name: "Paused",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "token",
        internalType: "address",
        type: "address",
        indexed: false,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Recovered",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "reward",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "RewardAdded",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      { name: "to", internalType: "address", type: "address", indexed: false },
      {
        name: "reward",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "RewardPaid",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "newRewardVaultManager",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "oldRewardVaultManager",
        internalType: "address",
        type: "address",
        indexed: true,
      },
    ],
    name: "RewardVaultManagerSet",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "newDuration",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "RewardsDurationUpdated",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Staked",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "newTargetRewardsPerSecond",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
      {
        name: "oldTargetRewardsPerSecond",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "TargetRewardsPerSecondUpdated",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: false,
      },
    ],
    name: "Unpaused",
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "account",
        internalType: "address",
        type: "address",
        indexed: true,
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false,
      },
    ],
    name: "Withdrawn",
  },
  {
    type: "function",
    inputs: [],
    name: "MAX_REWARD_DURATION",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "MIN_REWARD_DURATION",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "token", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "accountIncentives",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "token", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
      { name: "incentiveRate", internalType: "uint256", type: "uint256" },
    ],
    name: "addIncentive",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "beaconDepositContract",
    outputs: [{ name: "", internalType: "contract IBeaconDeposit", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "delegateStake",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "delegateWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "distributor",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "earned",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "recipient", internalType: "address", type: "address" }],
    name: "exit",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "factory",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "delegate", internalType: "address", type: "address" },
    ],
    name: "getDelegateStake",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "recipient", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "getPartialReward",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "recipient", internalType: "address", type: "address" },
    ],
    name: "getReward",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "getRewardForDuration",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "getTotalDelegateStaked",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "getWhitelistedTokens",
    outputs: [{ name: "", internalType: "address[]", type: "address[]" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "getWhitelistedTokensCount",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "token", internalType: "address", type: "address" }],
    name: "incentives",
    outputs: [
      { name: "minIncentiveRate", internalType: "uint256", type: "uint256" },
      { name: "incentiveRate", internalType: "uint256", type: "uint256" },
      { name: "amountRemaining", internalType: "uint256", type: "uint256" },
      { name: "manager", internalType: "address", type: "address" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      {
        name: "_beaconDepositContract",
        internalType: "address",
        type: "address",
      },
      { name: "_bgt", internalType: "address", type: "address" },
      { name: "_distributor", internalType: "address", type: "address" },
      { name: "_stakingToken", internalType: "address", type: "address" },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "user", internalType: "address", type: "address" }],
    name: "isFactoryOwner",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "user", internalType: "address", type: "address" }],
    name: "isFactoryVaultManager",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "user", internalType: "address", type: "address" }],
    name: "isFactoryVaultPauser",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "lastTimeRewardApplicable",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "lastUpdateTime",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "maxIncentiveTokensCount",
    outputs: [{ name: "", internalType: "uint8", type: "uint8" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "minRewardDurationForTargetRate",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "pubkey", internalType: "bytes", type: "bytes" },
      { name: "reward", internalType: "uint256", type: "uint256" },
    ],
    name: "notifyRewardAmount",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "operator",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "paused",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "pendingRewardsDuration",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "periodFinish",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "tokenAddress", internalType: "address", type: "address" },
      { name: "tokenAmount", internalType: "uint256", type: "uint256" },
    ],
    name: "recoverERC20",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "token", internalType: "address", type: "address" }],
    name: "removeIncentiveToken",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "rewardPerToken",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "rewardPerTokenStored",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "rewardRate",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "rewardToken",
    outputs: [{ name: "", internalType: "contract IERC20", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "rewardVaultManager",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "rewards",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "rewardsDuration",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "_rewardDistribution", internalType: "address", type: "address" }],
    name: "setDistributor",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      {
        name: "_maxIncentiveTokensCount",
        internalType: "uint8",
        type: "uint8",
      },
    ],
    name: "setMaxIncentiveTokensCount",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      {
        name: "_minRewardDurationForTargetRate",
        internalType: "uint256",
        type: "uint256",
      },
    ],
    name: "setMinRewardDurationForTargetRate",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_operator", internalType: "address", type: "address" }],
    name: "setOperator",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_rewardVaultManager", internalType: "address", type: "address" }],
    name: "setRewardVaultManager",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "_rewardsDuration", internalType: "uint256", type: "uint256" }],
    name: "setRewardsDuration",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      {
        name: "_targetRewardsPerSecond",
        internalType: "uint256",
        type: "uint256",
      },
    ],
    name: "setTargetRewardsPerSecond",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "amount", internalType: "uint256", type: "uint256" }],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "account", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" },
    ],
    name: "stakeOnBehalf",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [],
    name: "stakeToken",
    outputs: [{ name: "", internalType: "contract IERC20", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "targetRewardsPerSecond",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "undistributedRewards",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [
      { name: "token", internalType: "address", type: "address" },
      { name: "newManager", internalType: "address", type: "address" },
    ],
    name: "updateIncentiveManager",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "account", internalType: "address", type: "address" }],
    name: "userRewardPerTokenPaid",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [
      { name: "token", internalType: "address", type: "address" },
      { name: "minIncentiveRate", internalType: "uint256", type: "uint256" },
      { name: "manager", internalType: "address", type: "address" },
    ],
    name: "whitelistIncentiveToken",
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    name: "whitelistedTokens",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    inputs: [{ name: "amount", internalType: "uint256", type: "uint256" }],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
  },
] as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// React
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link aquaberaAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useReadAquabera = /*#__PURE__*/ createUseReadContract({
  abi: aquaberaAbi,
  address: aquaberaAddress,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link aquaberaAbi}__ and `functionName` set to `"ICHIVaultFactory"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useReadAquaberaIchiVaultFactory = /*#__PURE__*/ createUseReadContract({
  abi: aquaberaAbi,
  address: aquaberaAddress,
  functionName: "ICHIVaultFactory",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link aquaberaAbi}__ and `functionName` set to `"WRAPPED_NATIVE"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useReadAquaberaWrappedNative = /*#__PURE__*/ createUseReadContract({
  abi: aquaberaAbi,
  address: aquaberaAddress,
  functionName: "WRAPPED_NATIVE",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link aquaberaAbi}__ and `functionName` set to `"vaultKey"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useReadAquaberaVaultKey = /*#__PURE__*/ createUseReadContract({
  abi: aquaberaAbi,
  address: aquaberaAddress,
  functionName: "vaultKey",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link aquaberaAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useWriteAquabera = /*#__PURE__*/ createUseWriteContract({
  abi: aquaberaAbi,
  address: aquaberaAddress,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link aquaberaAbi}__ and `functionName` set to `"forwardDepositToICHIVault"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useWriteAquaberaForwardDepositToIchiVault = /*#__PURE__*/ createUseWriteContract({
  abi: aquaberaAbi,
  address: aquaberaAddress,
  functionName: "forwardDepositToICHIVault",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link aquaberaAbi}__ and `functionName` set to `"forwardNativeDepositToICHIVault"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useWriteAquaberaForwardNativeDepositToIchiVault = /*#__PURE__*/ createUseWriteContract(
  {
    abi: aquaberaAbi,
    address: aquaberaAddress,
    functionName: "forwardNativeDepositToICHIVault",
  },
);

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link aquaberaAbi}__ and `functionName` set to `"forwardNativeWithdrawFromICHIVault"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useWriteAquaberaForwardNativeWithdrawFromIchiVault =
  /*#__PURE__*/ createUseWriteContract({
    abi: aquaberaAbi,
    address: aquaberaAddress,
    functionName: "forwardNativeWithdrawFromICHIVault",
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link aquaberaAbi}__ and `functionName` set to `"forwardWithdrawFromICHIVault"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useWriteAquaberaForwardWithdrawFromIchiVault = /*#__PURE__*/ createUseWriteContract({
  abi: aquaberaAbi,
  address: aquaberaAddress,
  functionName: "forwardWithdrawFromICHIVault",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link aquaberaAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useSimulateAquabera = /*#__PURE__*/ createUseSimulateContract({
  abi: aquaberaAbi,
  address: aquaberaAddress,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link aquaberaAbi}__ and `functionName` set to `"forwardDepositToICHIVault"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useSimulateAquaberaForwardDepositToIchiVault = /*#__PURE__*/ createUseSimulateContract(
  {
    abi: aquaberaAbi,
    address: aquaberaAddress,
    functionName: "forwardDepositToICHIVault",
  },
);

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link aquaberaAbi}__ and `functionName` set to `"forwardNativeDepositToICHIVault"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useSimulateAquaberaForwardNativeDepositToIchiVault =
  /*#__PURE__*/ createUseSimulateContract({
    abi: aquaberaAbi,
    address: aquaberaAddress,
    functionName: "forwardNativeDepositToICHIVault",
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link aquaberaAbi}__ and `functionName` set to `"forwardNativeWithdrawFromICHIVault"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useSimulateAquaberaForwardNativeWithdrawFromIchiVault =
  /*#__PURE__*/ createUseSimulateContract({
    abi: aquaberaAbi,
    address: aquaberaAddress,
    functionName: "forwardNativeWithdrawFromICHIVault",
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link aquaberaAbi}__ and `functionName` set to `"forwardWithdrawFromICHIVault"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useSimulateAquaberaForwardWithdrawFromIchiVault =
  /*#__PURE__*/ createUseSimulateContract({
    abi: aquaberaAbi,
    address: aquaberaAddress,
    functionName: "forwardWithdrawFromICHIVault",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link aquaberaAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useWatchAquaberaEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: aquaberaAbi,
  address: aquaberaAddress,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link aquaberaAbi}__ and `eventName` set to `"Deployed"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useWatchAquaberaDeployedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: aquaberaAbi,
  address: aquaberaAddress,
  eventName: "Deployed",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link aquaberaAbi}__ and `eventName` set to `"DepositForwarded"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xc0c6D4178410849eC9765B4267A73F4F64241832)
 */
export const useWatchAquaberaDepositForwardedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: aquaberaAbi,
  address: aquaberaAddress,
  eventName: "DepositForwarded",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuction = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"auctionEndThresholdHrs"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionAuctionEndThresholdHrs = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "auctionEndThresholdHrs",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"auctionLengthInHours"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionAuctionLengthInHours = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "auctionLengthInHours",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"auctionStart"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionAuctionStart = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "auctionStart",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"auctionStatus"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionAuctionStatus = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "auctionStatus",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"beneficiaryAddress"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionBeneficiaryAddress = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "beneficiaryAddress",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"endWindows"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionEndWindows = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "endWindows",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"getBid"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionGetBid = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "getBid",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"itemsPerAuction"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionItemsPerAuction = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "itemsPerAuction",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"maximumQuantity"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionMaximumQuantity = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "maximumQuantity",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"minimumBidIncrement"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionMinimumBidIncrement = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "minimumBidIncrement",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"minimumQuantity"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionMinimumQuantity = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "minimumQuantity",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"minimumUnitPrice"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionMinimumUnitPrice = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "minimumUnitPrice",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"numberOfAuctions"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionNumberOfAuctions = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "numberOfAuctions",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"numberOfBidsPlaced"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionNumberOfBidsPlaced = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "numberOfBidsPlaced",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"owner"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionOwner = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "owner",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"paused"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionPaused = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "paused",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"refundMerkleRoot"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionRefundMerkleRoot = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "refundMerkleRoot",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"unitPriceStepSize"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadAuctionUnitPriceStepSize = /*#__PURE__*/ createUseReadContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "unitPriceStepSize",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link auctionAbi}__
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteAuction = /*#__PURE__*/ createUseWriteContract({
  abi: auctionAbi,
  address: auctionAddress,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"claimRefund"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteAuctionClaimRefund = /*#__PURE__*/ createUseWriteContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "claimRefund",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"endAuction"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteAuctionEndAuction = /*#__PURE__*/ createUseWriteContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "endAuction",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"pause"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteAuctionPause = /*#__PURE__*/ createUseWriteContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "pause",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"placeBid"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteAuctionPlaceBid = /*#__PURE__*/ createUseWriteContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "placeBid",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteAuctionRenounceOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"setRefundMerkleRoot"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteAuctionSetRefundMerkleRoot = /*#__PURE__*/ createUseWriteContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "setRefundMerkleRoot",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"startAuction"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteAuctionStartAuction = /*#__PURE__*/ createUseWriteContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "startAuction",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"transferERC20Token"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteAuctionTransferErc20Token = /*#__PURE__*/ createUseWriteContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "transferERC20Token",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteAuctionTransferOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"unpause"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteAuctionUnpause = /*#__PURE__*/ createUseWriteContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "unpause",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"withdrawContractBalance"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteAuctionWithdrawContractBalance = /*#__PURE__*/ createUseWriteContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "withdrawContractBalance",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link auctionAbi}__
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateAuction = /*#__PURE__*/ createUseSimulateContract({
  abi: auctionAbi,
  address: auctionAddress,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"claimRefund"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateAuctionClaimRefund = /*#__PURE__*/ createUseSimulateContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "claimRefund",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"endAuction"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateAuctionEndAuction = /*#__PURE__*/ createUseSimulateContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "endAuction",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"pause"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateAuctionPause = /*#__PURE__*/ createUseSimulateContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "pause",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"placeBid"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateAuctionPlaceBid = /*#__PURE__*/ createUseSimulateContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "placeBid",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateAuctionRenounceOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"setRefundMerkleRoot"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateAuctionSetRefundMerkleRoot = /*#__PURE__*/ createUseSimulateContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "setRefundMerkleRoot",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"startAuction"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateAuctionStartAuction = /*#__PURE__*/ createUseSimulateContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "startAuction",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"transferERC20Token"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateAuctionTransferErc20Token = /*#__PURE__*/ createUseSimulateContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "transferERC20Token",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateAuctionTransferOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"unpause"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateAuctionUnpause = /*#__PURE__*/ createUseSimulateContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "unpause",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link auctionAbi}__ and `functionName` set to `"withdrawContractBalance"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateAuctionWithdrawContractBalance = /*#__PURE__*/ createUseSimulateContract({
  abi: auctionAbi,
  address: auctionAddress,
  functionName: "withdrawContractBalance",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link auctionAbi}__
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchAuctionEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: auctionAbi,
  address: auctionAddress,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link auctionAbi}__ and `eventName` set to `"AuctionEnded"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchAuctionAuctionEndedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: auctionAbi,
  address: auctionAddress,
  eventName: "AuctionEnded",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link auctionAbi}__ and `eventName` set to `"AuctionStarted"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchAuctionAuctionStartedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: auctionAbi,
  address: auctionAddress,
  eventName: "AuctionStarted",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link auctionAbi}__ and `eventName` set to `"BidPlaced"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchAuctionBidPlacedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: auctionAbi,
  address: auctionAddress,
  eventName: "BidPlaced",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link auctionAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchAuctionOwnershipTransferredEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: auctionAbi,
  address: auctionAddress,
  eventName: "OwnershipTransferred",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link auctionAbi}__ and `eventName` set to `"Paused"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchAuctionPausedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: auctionAbi,
  address: auctionAddress,
  eventName: "Paused",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link auctionAbi}__ and `eventName` set to `"RefundIssued"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchAuctionRefundIssuedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: auctionAbi,
  address: auctionAddress,
  eventName: "RefundIssued",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link auctionAbi}__ and `eventName` set to `"Unpaused"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchAuctionUnpausedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: auctionAbi,
  address: auctionAddress,
  eventName: "Unpaused",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beradromePluginAbi}__
 */
export const useReadBeradromePlugin = /*#__PURE__*/ createUseReadContract({
  abi: beradromePluginAbi,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadBeradromePluginBalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: beradromePluginAbi,
  functionName: "balanceOf",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"getAssetTokens"`
 */
export const useReadBeradromePluginGetAssetTokens = /*#__PURE__*/ createUseReadContract({
  abi: beradromePluginAbi,
  functionName: "getAssetTokens",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"getBribe"`
 */
export const useReadBeradromePluginGetBribe = /*#__PURE__*/ createUseReadContract({
  abi: beradromePluginAbi,
  functionName: "getBribe",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"getBribeTokens"`
 */
export const useReadBeradromePluginGetBribeTokens = /*#__PURE__*/ createUseReadContract({
  abi: beradromePluginAbi,
  functionName: "getBribeTokens",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"getGauge"`
 */
export const useReadBeradromePluginGetGauge = /*#__PURE__*/ createUseReadContract({
  abi: beradromePluginAbi,
  functionName: "getGauge",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"getName"`
 */
export const useReadBeradromePluginGetName = /*#__PURE__*/ createUseReadContract({
  abi: beradromePluginAbi,
  functionName: "getName",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"getProtocol"`
 */
export const useReadBeradromePluginGetProtocol = /*#__PURE__*/ createUseReadContract({
  abi: beradromePluginAbi,
  functionName: "getProtocol",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"getRewardVault"`
 */
export const useReadBeradromePluginGetRewardVault = /*#__PURE__*/ createUseReadContract({
  abi: beradromePluginAbi,
  functionName: "getRewardVault",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"getToken"`
 */
export const useReadBeradromePluginGetToken = /*#__PURE__*/ createUseReadContract({
  abi: beradromePluginAbi,
  functionName: "getToken",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"getVaultToken"`
 */
export const useReadBeradromePluginGetVaultToken = /*#__PURE__*/ createUseReadContract({
  abi: beradromePluginAbi,
  functionName: "getVaultToken",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"getVoter"`
 */
export const useReadBeradromePluginGetVoter = /*#__PURE__*/ createUseReadContract({
  abi: beradromePluginAbi,
  functionName: "getVoter",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadBeradromePluginTotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: beradromePluginAbi,
  functionName: "totalSupply",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beradromePluginAbi}__
 */
export const useWriteBeradromePlugin = /*#__PURE__*/ createUseWriteContract({
  abi: beradromePluginAbi,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"claimAndDistribute"`
 */
export const useWriteBeradromePluginClaimAndDistribute = /*#__PURE__*/ createUseWriteContract({
  abi: beradromePluginAbi,
  functionName: "claimAndDistribute",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"depositFor"`
 */
export const useWriteBeradromePluginDepositFor = /*#__PURE__*/ createUseWriteContract({
  abi: beradromePluginAbi,
  functionName: "depositFor",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"setBribe"`
 */
export const useWriteBeradromePluginSetBribe = /*#__PURE__*/ createUseWriteContract({
  abi: beradromePluginAbi,
  functionName: "setBribe",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"setGauge"`
 */
export const useWriteBeradromePluginSetGauge = /*#__PURE__*/ createUseWriteContract({
  abi: beradromePluginAbi,
  functionName: "setGauge",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"withdrawTo"`
 */
export const useWriteBeradromePluginWithdrawTo = /*#__PURE__*/ createUseWriteContract({
  abi: beradromePluginAbi,
  functionName: "withdrawTo",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beradromePluginAbi}__
 */
export const useSimulateBeradromePlugin = /*#__PURE__*/ createUseSimulateContract({
  abi: beradromePluginAbi,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"claimAndDistribute"`
 */
export const useSimulateBeradromePluginClaimAndDistribute = /*#__PURE__*/ createUseSimulateContract(
  {
    abi: beradromePluginAbi,
    functionName: "claimAndDistribute",
  },
);

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"depositFor"`
 */
export const useSimulateBeradromePluginDepositFor = /*#__PURE__*/ createUseSimulateContract({
  abi: beradromePluginAbi,
  functionName: "depositFor",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"setBribe"`
 */
export const useSimulateBeradromePluginSetBribe = /*#__PURE__*/ createUseSimulateContract({
  abi: beradromePluginAbi,
  functionName: "setBribe",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"setGauge"`
 */
export const useSimulateBeradromePluginSetGauge = /*#__PURE__*/ createUseSimulateContract({
  abi: beradromePluginAbi,
  functionName: "setGauge",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link beradromePluginAbi}__ and `functionName` set to `"withdrawTo"`
 */
export const useSimulateBeradromePluginWithdrawTo = /*#__PURE__*/ createUseSimulateContract({
  abi: beradromePluginAbi,
  functionName: "withdrawTo",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beradromePluginAbi}__
 */
export const useWatchBeradromePluginEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: beradromePluginAbi,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beradromePluginAbi}__ and `eventName` set to `"Plugin__ClaimedAnDistributed"`
 */
export const useWatchBeradromePluginPluginClaimedAnDistributedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beradromePluginAbi,
    eventName: "Plugin__ClaimedAnDistributed",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beradromePluginAbi}__ and `eventName` set to `"Plugin__Deposited"`
 */
export const useWatchBeradromePluginPluginDepositedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beradromePluginAbi,
    eventName: "Plugin__Deposited",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link beradromePluginAbi}__ and `eventName` set to `"Plugin__Withdrawn"`
 */
export const useWatchBeradromePluginPluginWithdrawnEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: beradromePluginAbi,
    eventName: "Plugin__Withdrawn",
  });

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgt = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"CLOCK_MODE"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtClockMode = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "CLOCK_MODE",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"activateBoostDelay"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtActivateBoostDelay = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "activateBoostDelay",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"allowance"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtAllowance = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "allowance",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"balanceOf"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtBalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "balanceOf",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"bgtTermsAndConditions"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtBgtTermsAndConditions = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "bgtTermsAndConditions",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"boosted"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtBoosted = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "boosted",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"boostedQueue"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtBoostedQueue = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "boostedQueue",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"boostees"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtBoostees = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "boostees",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"boosts"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtBoosts = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "boosts",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"checkpoints"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtCheckpoints = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "checkpoints",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"clock"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtClock = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "clock",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"decimals"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtDecimals = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "decimals",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"delegates"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtDelegates = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "delegates",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"dropBoostDelay"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtDropBoostDelay = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "dropBoostDelay",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"dropBoostQueue"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtDropBoostQueue = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "dropBoostQueue",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"eip712Domain"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtEip712Domain = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "eip712Domain",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"getPastTotalSupply"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtGetPastTotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "getPastTotalSupply",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"getPastVotes"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtGetPastVotes = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "getPastVotes",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"getVotes"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtGetVotes = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "getVotes",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"isWhitelistedSender"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtIsWhitelistedSender = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "isWhitelistedSender",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"minter"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtMinter = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "minter",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"name"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtName = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "name",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"nonces"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtNonces = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "nonces",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"normalizedBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtNormalizedBoost = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "normalizedBoost",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"numCheckpoints"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtNumCheckpoints = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "numCheckpoints",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"owner"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtOwner = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "owner",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"queuedBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtQueuedBoost = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "queuedBoost",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"staker"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtStaker = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "staker",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"symbol"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtSymbol = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "symbol",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"totalBoosts"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtTotalBoosts = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "totalBoosts",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"totalSupply"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtTotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "totalSupply",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"unboostedBalanceOf"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useReadBgtUnboostedBalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "unboostedBalanceOf",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgt = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"activateBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtActivateBoost = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "activateBoost",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtApprove = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "approve",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"burnExceedingReserves"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtBurnExceedingReserves = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "burnExceedingReserves",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"cancelBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtCancelBoost = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "cancelBoost",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"cancelDropBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtCancelDropBoost = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "cancelDropBoost",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"delegate"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtDelegate = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "delegate",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"delegateBySig"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtDelegateBySig = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "delegateBySig",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"dropBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtDropBoost = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "dropBoost",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"initialize"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtInitialize = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "initialize",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"mint"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtMint = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "mint",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"multicall"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtMulticall = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "multicall",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"queueBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtQueueBoost = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "queueBoost",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"queueDropBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtQueueDropBoost = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "queueDropBoost",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"redeem"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtRedeem = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "redeem",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtRenounceOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"setActivateBoostDelay"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtSetActivateBoostDelay = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "setActivateBoostDelay",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"setBgtTermsAndConditions"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtSetBgtTermsAndConditions = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "setBgtTermsAndConditions",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"setDropBoostDelay"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtSetDropBoostDelay = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "setDropBoostDelay",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"setMinter"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtSetMinter = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "setMinter",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"setStaker"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtSetStaker = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "setStaker",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"transfer"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtTransfer = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "transfer",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtTransferFrom = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "transferFrom",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtTransferOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"whitelistSender"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWriteBgtWhitelistSender = /*#__PURE__*/ createUseWriteContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "whitelistSender",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgt = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"activateBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtActivateBoost = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "activateBoost",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtApprove = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "approve",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"burnExceedingReserves"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtBurnExceedingReserves = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "burnExceedingReserves",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"cancelBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtCancelBoost = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "cancelBoost",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"cancelDropBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtCancelDropBoost = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "cancelDropBoost",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"delegate"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtDelegate = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "delegate",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"delegateBySig"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtDelegateBySig = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "delegateBySig",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"dropBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtDropBoost = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "dropBoost",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"initialize"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtInitialize = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "initialize",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"mint"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtMint = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "mint",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"multicall"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtMulticall = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "multicall",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"queueBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtQueueBoost = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "queueBoost",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"queueDropBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtQueueDropBoost = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "queueDropBoost",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"redeem"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtRedeem = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "redeem",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtRenounceOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"setActivateBoostDelay"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtSetActivateBoostDelay = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "setActivateBoostDelay",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"setBgtTermsAndConditions"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtSetBgtTermsAndConditions = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "setBgtTermsAndConditions",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"setDropBoostDelay"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtSetDropBoostDelay = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "setDropBoostDelay",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"setMinter"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtSetMinter = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "setMinter",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"setStaker"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtSetStaker = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "setStaker",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"transfer"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtTransfer = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "transfer",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtTransferFrom = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "transferFrom",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtTransferOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link bgtAbi}__ and `functionName` set to `"whitelistSender"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useSimulateBgtWhitelistSender = /*#__PURE__*/ createUseSimulateContract({
  abi: bgtAbi,
  address: bgtAddress,
  functionName: "whitelistSender",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"ActivateBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtActivateBoostEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "ActivateBoost",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"ActivateBoostDelayChanged"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtActivateBoostDelayChangedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "ActivateBoostDelayChanged",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"Approval"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtApprovalEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "Approval",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"BgtTermsAndConditionsChanged"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtBgtTermsAndConditionsChangedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: bgtAbi,
    address: bgtAddress,
    eventName: "BgtTermsAndConditionsChanged",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"CancelBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtCancelBoostEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "CancelBoost",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"CancelDropBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtCancelDropBoostEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "CancelDropBoost",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"DelegateChanged"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtDelegateChangedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "DelegateChanged",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"DelegateVotesChanged"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtDelegateVotesChangedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "DelegateVotesChanged",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"DropBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtDropBoostEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "DropBoost",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"DropBoostDelayChanged"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtDropBoostDelayChangedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "DropBoostDelayChanged",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"EIP712DomainChanged"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtEip712DomainChangedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "EIP712DomainChanged",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"ExceedingReservesBurnt"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtExceedingReservesBurntEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "ExceedingReservesBurnt",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"Initialized"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtInitializedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "Initialized",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"MinterChanged"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtMinterChangedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "MinterChanged",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtOwnershipTransferredEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "OwnershipTransferred",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"QueueBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtQueueBoostEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "QueueBoost",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"QueueDropBoost"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtQueueDropBoostEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "QueueDropBoost",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"Redeem"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtRedeemEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "Redeem",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"SenderWhitelisted"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtSenderWhitelistedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "SenderWhitelisted",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"StakerChanged"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtStakerChangedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "StakerChanged",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link bgtAbi}__ and `eventName` set to `"Transfer"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x656b95E550C07a9ffe548bd4085c72418Ceb1dba)
 */
export const useWatchBgtTransferEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: bgtAbi,
  address: bgtAddress,
  eventName: "Transfer",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__
 */
export const useReadErc20 = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"allowance"`
 */
export const useReadErc20Allowance = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
  functionName: "allowance",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadErc20BalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
  functionName: "balanceOf",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"decimals"`
 */
export const useReadErc20Decimals = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
  functionName: "decimals",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"name"`
 */
export const useReadErc20Name = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
  functionName: "name",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"symbol"`
 */
export const useReadErc20Symbol = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
  functionName: "symbol",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadErc20TotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: erc20Abi,
  functionName: "totalSupply",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc20Abi}__
 */
export const useWriteErc20 = /*#__PURE__*/ createUseWriteContract({
  abi: erc20Abi,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"approve"`
 */
export const useWriteErc20Approve = /*#__PURE__*/ createUseWriteContract({
  abi: erc20Abi,
  functionName: "approve",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"transfer"`
 */
export const useWriteErc20Transfer = /*#__PURE__*/ createUseWriteContract({
  abi: erc20Abi,
  functionName: "transfer",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteErc20TransferFrom = /*#__PURE__*/ createUseWriteContract({
  abi: erc20Abi,
  functionName: "transferFrom",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc20Abi}__
 */
export const useSimulateErc20 = /*#__PURE__*/ createUseSimulateContract({
  abi: erc20Abi,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"approve"`
 */
export const useSimulateErc20Approve = /*#__PURE__*/ createUseSimulateContract({
  abi: erc20Abi,
  functionName: "approve",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"transfer"`
 */
export const useSimulateErc20Transfer = /*#__PURE__*/ createUseSimulateContract({
  abi: erc20Abi,
  functionName: "transfer",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc20Abi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateErc20TransferFrom = /*#__PURE__*/ createUseSimulateContract({
  abi: erc20Abi,
  functionName: "transferFrom",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc20Abi}__
 */
export const useWatchErc20Event = /*#__PURE__*/ createUseWatchContractEvent({
  abi: erc20Abi,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc20Abi}__ and `eventName` set to `"Approval"`
 */
export const useWatchErc20ApprovalEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: erc20Abi,
  eventName: "Approval",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc20Abi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchErc20TransferEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: erc20Abi,
  eventName: "Transfer",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link exchangeAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x1Ab7624d3a07e0D5AC161EEaE45D841c15441c95)
 */
export const useWriteExchange = /*#__PURE__*/ createUseWriteContract({
  abi: exchangeAbi,
  address: exchangeAddress,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link exchangeAbi}__ and `functionName` set to `"exchange"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x1Ab7624d3a07e0D5AC161EEaE45D841c15441c95)
 */
export const useWriteExchangeExchange = /*#__PURE__*/ createUseWriteContract({
  abi: exchangeAbi,
  address: exchangeAddress,
  functionName: "exchange",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link exchangeAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x1Ab7624d3a07e0D5AC161EEaE45D841c15441c95)
 */
export const useSimulateExchange = /*#__PURE__*/ createUseSimulateContract({
  abi: exchangeAbi,
  address: exchangeAddress,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link exchangeAbi}__ and `functionName` set to `"exchange"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x1Ab7624d3a07e0D5AC161EEaE45D841c15441c95)
 */
export const useSimulateExchangeExchange = /*#__PURE__*/ createUseSimulateContract({
  abi: exchangeAbi,
  address: exchangeAddress,
  functionName: "exchange",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link fdvReaderAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xD5F76a363135A0781295043241f18496dAa31E3d)
 */
export const useReadFdvReader = /*#__PURE__*/ createUseReadContract({
  abi: fdvReaderAbi,
  address: fdvReaderAddress,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link fdvReaderAbi}__ and `functionName` set to `"readAsUint64WithTimestamp"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xD5F76a363135A0781295043241f18496dAa31E3d)
 */
export const useReadFdvReaderReadAsUint64WithTimestamp = /*#__PURE__*/ createUseReadContract({
  abi: fdvReaderAbi,
  address: fdvReaderAddress,
  functionName: "readAsUint64WithTimestamp",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__
 */
export const useReadGauge = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"DURATION"`
 */
export const useReadGaugeDuration = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "DURATION",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadGaugeBalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "balanceOf",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"earned"`
 */
export const useReadGaugeEarned = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "earned",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"getRewardForDuration"`
 */
export const useReadGaugeGetRewardForDuration = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "getRewardForDuration",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"getRewardTokens"`
 */
export const useReadGaugeGetRewardTokens = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "getRewardTokens",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"isRewardToken"`
 */
export const useReadGaugeIsRewardToken = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "isRewardToken",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"lastTimeRewardApplicable"`
 */
export const useReadGaugeLastTimeRewardApplicable = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "lastTimeRewardApplicable",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"left"`
 */
export const useReadGaugeLeft = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "left",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"plugin"`
 */
export const useReadGaugePlugin = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "plugin",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"rewardData"`
 */
export const useReadGaugeRewardData = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "rewardData",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"rewardPerToken"`
 */
export const useReadGaugeRewardPerToken = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "rewardPerToken",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"rewardTokens"`
 */
export const useReadGaugeRewardTokens = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "rewardTokens",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"rewards"`
 */
export const useReadGaugeRewards = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "rewards",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadGaugeTotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "totalSupply",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"userRewardPerTokenPaid"`
 */
export const useReadGaugeUserRewardPerTokenPaid = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "userRewardPerTokenPaid",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"voter"`
 */
export const useReadGaugeVoter = /*#__PURE__*/ createUseReadContract({
  abi: gaugeAbi,
  functionName: "voter",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link gaugeAbi}__
 */
export const useWriteGauge = /*#__PURE__*/ createUseWriteContract({
  abi: gaugeAbi,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"_deposit"`
 */
export const useWriteGaugeDeposit = /*#__PURE__*/ createUseWriteContract({
  abi: gaugeAbi,
  functionName: "_deposit",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"_withdraw"`
 */
export const useWriteGaugeWithdraw = /*#__PURE__*/ createUseWriteContract({
  abi: gaugeAbi,
  functionName: "_withdraw",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"addReward"`
 */
export const useWriteGaugeAddReward = /*#__PURE__*/ createUseWriteContract({
  abi: gaugeAbi,
  functionName: "addReward",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"getReward"`
 */
export const useWriteGaugeGetReward = /*#__PURE__*/ createUseWriteContract({
  abi: gaugeAbi,
  functionName: "getReward",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"notifyRewardAmount"`
 */
export const useWriteGaugeNotifyRewardAmount = /*#__PURE__*/ createUseWriteContract({
  abi: gaugeAbi,
  functionName: "notifyRewardAmount",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link gaugeAbi}__
 */
export const useSimulateGauge = /*#__PURE__*/ createUseSimulateContract({
  abi: gaugeAbi,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"_deposit"`
 */
export const useSimulateGaugeDeposit = /*#__PURE__*/ createUseSimulateContract({
  abi: gaugeAbi,
  functionName: "_deposit",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"_withdraw"`
 */
export const useSimulateGaugeWithdraw = /*#__PURE__*/ createUseSimulateContract({
  abi: gaugeAbi,
  functionName: "_withdraw",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"addReward"`
 */
export const useSimulateGaugeAddReward = /*#__PURE__*/ createUseSimulateContract({
  abi: gaugeAbi,
  functionName: "addReward",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"getReward"`
 */
export const useSimulateGaugeGetReward = /*#__PURE__*/ createUseSimulateContract({
  abi: gaugeAbi,
  functionName: "getReward",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link gaugeAbi}__ and `functionName` set to `"notifyRewardAmount"`
 */
export const useSimulateGaugeNotifyRewardAmount = /*#__PURE__*/ createUseSimulateContract({
  abi: gaugeAbi,
  functionName: "notifyRewardAmount",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link gaugeAbi}__
 */
export const useWatchGaugeEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: gaugeAbi,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link gaugeAbi}__ and `eventName` set to `"Gauge__Deposited"`
 */
export const useWatchGaugeGaugeDepositedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: gaugeAbi,
  eventName: "Gauge__Deposited",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link gaugeAbi}__ and `eventName` set to `"Gauge__RewardAdded"`
 */
export const useWatchGaugeGaugeRewardAddedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: gaugeAbi,
  eventName: "Gauge__RewardAdded",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link gaugeAbi}__ and `eventName` set to `"Gauge__RewardNotified"`
 */
export const useWatchGaugeGaugeRewardNotifiedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: gaugeAbi,
  eventName: "Gauge__RewardNotified",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link gaugeAbi}__ and `eventName` set to `"Gauge__RewardPaid"`
 */
export const useWatchGaugeGaugeRewardPaidEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: gaugeAbi,
  eventName: "Gauge__RewardPaid",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link gaugeAbi}__ and `eventName` set to `"Gauge__Withdrawn"`
 */
export const useWatchGaugeGaugeWithdrawnEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: gaugeAbi,
  eventName: "Gauge__Withdrawn",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloAbi}__
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useReadHenlo = /*#__PURE__*/ createUseReadContract({
  abi: henloAbi,
  address: henloAddress,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloAbi}__ and `functionName` set to `"allowance"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useReadHenloAllowance = /*#__PURE__*/ createUseReadContract({
  abi: henloAbi,
  address: henloAddress,
  functionName: "allowance",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloAbi}__ and `functionName` set to `"balanceOf"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useReadHenloBalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: henloAbi,
  address: henloAddress,
  functionName: "balanceOf",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloAbi}__ and `functionName` set to `"decimals"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useReadHenloDecimals = /*#__PURE__*/ createUseReadContract({
  abi: henloAbi,
  address: henloAddress,
  functionName: "decimals",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloAbi}__ and `functionName` set to `"name"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useReadHenloName = /*#__PURE__*/ createUseReadContract({
  abi: henloAbi,
  address: henloAddress,
  functionName: "name",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloAbi}__ and `functionName` set to `"symbol"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useReadHenloSymbol = /*#__PURE__*/ createUseReadContract({
  abi: henloAbi,
  address: henloAddress,
  functionName: "symbol",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloAbi}__ and `functionName` set to `"totalSupply"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useReadHenloTotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: henloAbi,
  address: henloAddress,
  functionName: "totalSupply",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloAbi}__
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useWriteHenlo = /*#__PURE__*/ createUseWriteContract({
  abi: henloAbi,
  address: henloAddress,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useWriteHenloApprove = /*#__PURE__*/ createUseWriteContract({
  abi: henloAbi,
  address: henloAddress,
  functionName: "approve",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useWriteHenloTransfer = /*#__PURE__*/ createUseWriteContract({
  abi: henloAbi,
  address: henloAddress,
  functionName: "transfer",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useWriteHenloTransferFrom = /*#__PURE__*/ createUseWriteContract({
  abi: henloAbi,
  address: henloAddress,
  functionName: "transferFrom",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloAbi}__
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useSimulateHenlo = /*#__PURE__*/ createUseSimulateContract({
  abi: henloAbi,
  address: henloAddress,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloAbi}__ and `functionName` set to `"approve"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useSimulateHenloApprove = /*#__PURE__*/ createUseSimulateContract({
  abi: henloAbi,
  address: henloAddress,
  functionName: "approve",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloAbi}__ and `functionName` set to `"transfer"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useSimulateHenloTransfer = /*#__PURE__*/ createUseSimulateContract({
  abi: henloAbi,
  address: henloAddress,
  functionName: "transfer",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloAbi}__ and `functionName` set to `"transferFrom"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useSimulateHenloTransferFrom = /*#__PURE__*/ createUseSimulateContract({
  abi: henloAbi,
  address: henloAddress,
  functionName: "transferFrom",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloAbi}__
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useWatchHenloEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloAbi,
  address: henloAddress,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloAbi}__ and `eventName` set to `"Approval"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useWatchHenloApprovalEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloAbi,
  address: henloAddress,
  eventName: "Approval",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloAbi}__ and `eventName` set to `"Transfer"`
 *
 * - [__View Contract on Berachain Bepolia Berascan__](https://bepolia.beratrail.io/address/0x886D2176D899796cD1AfFA07Eff07B9b2B80f1be)
 * - [__View Contract on Berachain Berascan__](https://berascan.com/address/0xb2F776e9c1C926C4b2e54182Fac058dA9Af0B6A5)
 */
export const useWatchHenloTransferEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloAbi,
  address: henloAddress,
  eventName: "Transfer",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloCardsAbi}__
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useReadHenloCards = /*#__PURE__*/ createUseReadContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"balanceOf"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useReadHenloCardsBalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "balanceOf",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"getApproved"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useReadHenloCardsGetApproved = /*#__PURE__*/ createUseReadContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "getApproved",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"isApprovedForAll"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useReadHenloCardsIsApprovedForAll = /*#__PURE__*/ createUseReadContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "isApprovedForAll",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"name"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useReadHenloCardsName = /*#__PURE__*/ createUseReadContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "name",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"owner"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useReadHenloCardsOwner = /*#__PURE__*/ createUseReadContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "owner",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"ownerOf"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useReadHenloCardsOwnerOf = /*#__PURE__*/ createUseReadContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "ownerOf",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"ownershipHandoverExpiresAt"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useReadHenloCardsOwnershipHandoverExpiresAt = /*#__PURE__*/ createUseReadContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "ownershipHandoverExpiresAt",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"price"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useReadHenloCardsPrice = /*#__PURE__*/ createUseReadContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "price",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"supportsInterface"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useReadHenloCardsSupportsInterface = /*#__PURE__*/ createUseReadContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "supportsInterface",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"symbol"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useReadHenloCardsSymbol = /*#__PURE__*/ createUseReadContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "symbol",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"tokenURI"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useReadHenloCardsTokenUri = /*#__PURE__*/ createUseReadContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "tokenURI",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCards = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCardsApprove = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "approve",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"cancelOwnershipHandover"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCardsCancelOwnershipHandover = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "cancelOwnershipHandover",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"completeOwnershipHandover"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCardsCompleteOwnershipHandover = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "completeOwnershipHandover",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"mint"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCardsMint = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "mint",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCardsRenounceOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"requestOwnershipHandover"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCardsRequestOwnershipHandover = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "requestOwnershipHandover",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"safeTransferFrom"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCardsSafeTransferFrom = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "safeTransferFrom",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"setApprovalForAll"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCardsSetApprovalForAll = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "setApprovalForAll",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"setBaseURI"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCardsSetBaseUri = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "setBaseURI",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"setPrice"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCardsSetPrice = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "setPrice",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCardsTransferFrom = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "transferFrom",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCardsTransferOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"withdraw"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWriteHenloCardsWithdraw = /*#__PURE__*/ createUseWriteContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "withdraw",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCards = /*#__PURE__*/ createUseSimulateContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCardsApprove = /*#__PURE__*/ createUseSimulateContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "approve",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"cancelOwnershipHandover"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCardsCancelOwnershipHandover = /*#__PURE__*/ createUseSimulateContract(
  {
    abi: henloCardsAbi,
    address: henloCardsAddress,
    functionName: "cancelOwnershipHandover",
  },
);

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"completeOwnershipHandover"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCardsCompleteOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: henloCardsAbi,
    address: henloCardsAddress,
    functionName: "completeOwnershipHandover",
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"mint"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCardsMint = /*#__PURE__*/ createUseSimulateContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "mint",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCardsRenounceOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"requestOwnershipHandover"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCardsRequestOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: henloCardsAbi,
    address: henloCardsAddress,
    functionName: "requestOwnershipHandover",
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"safeTransferFrom"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCardsSafeTransferFrom = /*#__PURE__*/ createUseSimulateContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "safeTransferFrom",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"setApprovalForAll"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCardsSetApprovalForAll = /*#__PURE__*/ createUseSimulateContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "setApprovalForAll",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"setBaseURI"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCardsSetBaseUri = /*#__PURE__*/ createUseSimulateContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "setBaseURI",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"setPrice"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCardsSetPrice = /*#__PURE__*/ createUseSimulateContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "setPrice",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCardsTransferFrom = /*#__PURE__*/ createUseSimulateContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "transferFrom",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCardsTransferOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloCardsAbi}__ and `functionName` set to `"withdraw"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useSimulateHenloCardsWithdraw = /*#__PURE__*/ createUseSimulateContract({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  functionName: "withdraw",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloCardsAbi}__
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWatchHenloCardsEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloCardsAbi,
  address: henloCardsAddress,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloCardsAbi}__ and `eventName` set to `"Approval"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWatchHenloCardsApprovalEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  eventName: "Approval",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloCardsAbi}__ and `eventName` set to `"ApprovalForAll"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWatchHenloCardsApprovalForAllEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  eventName: "ApprovalForAll",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloCardsAbi}__ and `eventName` set to `"OwnershipHandoverCanceled"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWatchHenloCardsOwnershipHandoverCanceledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: henloCardsAbi,
    address: henloCardsAddress,
    eventName: "OwnershipHandoverCanceled",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloCardsAbi}__ and `eventName` set to `"OwnershipHandoverRequested"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWatchHenloCardsOwnershipHandoverRequestedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: henloCardsAbi,
    address: henloCardsAddress,
    eventName: "OwnershipHandoverRequested",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloCardsAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWatchHenloCardsOwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: henloCardsAbi,
    address: henloCardsAddress,
    eventName: "OwnershipTransferred",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloCardsAbi}__ and `eventName` set to `"Transfer"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0xd51FD6C7d5850E054628aC4137c1984Fb86d02dC)
 */
export const useWatchHenloCardsTransferEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloCardsAbi,
  address: henloCardsAddress,
  eventName: "Transfer",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptions = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"DOMAIN_SEPARATOR"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptionsDomainSeparator = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "DOMAIN_SEPARATOR",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"allowance"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptionsAllowance = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "allowance",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"balanceOf"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptionsBalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "balanceOf",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"claimed"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptionsClaimed = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "claimed",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"decimals"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptionsDecimals = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "decimals",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"expiresAt"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptionsExpiresAt = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "expiresAt",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"name"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptionsName = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "name",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"nonces"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptionsNonces = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "nonces",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"owner"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptionsOwner = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "owner",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"ownershipHandoverExpiresAt"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptionsOwnershipHandoverExpiresAt = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "ownershipHandoverExpiresAt",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"pricePerHenlo"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptionsPricePerHenlo = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "pricePerHenlo",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"symbol"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptionsSymbol = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "symbol",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"totalSupply"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useReadHenloOptionsTotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "totalSupply",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptions = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsApprove = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "approve",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"cancelOwnershipHandover"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsCancelOwnershipHandover = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "cancelOwnershipHandover",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"claim"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsClaim = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "claim",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"completeOwnershipHandover"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsCompleteOwnershipHandover = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "completeOwnershipHandover",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"exercise"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsExercise = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "exercise",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"launch"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsLaunch = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "launch",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"permit"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsPermit = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "permit",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsRenounceOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"requestOwnershipHandover"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsRequestOwnershipHandover = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "requestOwnershipHandover",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"setExpiresAt"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsSetExpiresAt = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "setExpiresAt",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"setMerkleRoot"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsSetMerkleRoot = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "setMerkleRoot",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"transfer"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsTransfer = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "transfer",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsTransferFrom = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "transferFrom",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsTransferOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"withdrawBERA"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsWithdrawBera = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "withdrawBERA",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"withdrawHenlo"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWriteHenloOptionsWithdrawHenlo = /*#__PURE__*/ createUseWriteContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "withdrawHenlo",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptions = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsApprove = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "approve",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"cancelOwnershipHandover"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsCancelOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: henloOptionsAbi,
    address: henloOptionsAddress,
    functionName: "cancelOwnershipHandover",
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"claim"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsClaim = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "claim",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"completeOwnershipHandover"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsCompleteOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: henloOptionsAbi,
    address: henloOptionsAddress,
    functionName: "completeOwnershipHandover",
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"exercise"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsExercise = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "exercise",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"launch"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsLaunch = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "launch",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"permit"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsPermit = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "permit",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsRenounceOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"requestOwnershipHandover"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsRequestOwnershipHandover =
  /*#__PURE__*/ createUseSimulateContract({
    abi: henloOptionsAbi,
    address: henloOptionsAddress,
    functionName: "requestOwnershipHandover",
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"setExpiresAt"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsSetExpiresAt = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "setExpiresAt",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"setMerkleRoot"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsSetMerkleRoot = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "setMerkleRoot",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"transfer"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsTransfer = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "transfer",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsTransferFrom = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "transferFrom",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsTransferOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"withdrawBERA"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsWithdrawBera = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "withdrawBERA",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloOptionsAbi}__ and `functionName` set to `"withdrawHenlo"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useSimulateHenloOptionsWithdrawHenlo = /*#__PURE__*/ createUseSimulateContract({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  functionName: "withdrawHenlo",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloOptionsAbi}__
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchHenloOptionsEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloOptionsAbi}__ and `eventName` set to `"Approval"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchHenloOptionsApprovalEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  eventName: "Approval",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloOptionsAbi}__ and `eventName` set to `"OwnershipHandoverCanceled"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchHenloOptionsOwnershipHandoverCanceledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: henloOptionsAbi,
    address: henloOptionsAddress,
    eventName: "OwnershipHandoverCanceled",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloOptionsAbi}__ and `eventName` set to `"OwnershipHandoverRequested"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchHenloOptionsOwnershipHandoverRequestedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: henloOptionsAbi,
    address: henloOptionsAddress,
    eventName: "OwnershipHandoverRequested",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloOptionsAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchHenloOptionsOwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: henloOptionsAbi,
    address: henloOptionsAddress,
    eventName: "OwnershipTransferred",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloOptionsAbi}__ and `eventName` set to `"Transfer"`
 *
 * [__View Contract on Sepolia Etherscan__](https://sepolia.etherscan.io/address/0x01658783645a0C6cC0e658669486D4E98F0F8865)
 */
export const useWatchHenloOptionsTransferEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloOptionsAbi,
  address: henloOptionsAddress,
  eventName: "Transfer",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloPfpAbi}__
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useReadHenloPfp = /*#__PURE__*/ createUseReadContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"balanceOf"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useReadHenloPfpBalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "balanceOf",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"balanceOfBatch"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useReadHenloPfpBalanceOfBatch = /*#__PURE__*/ createUseReadContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "balanceOfBatch",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"isApprovedForAll"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useReadHenloPfpIsApprovedForAll = /*#__PURE__*/ createUseReadContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "isApprovedForAll",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"maxSupply"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useReadHenloPfpMaxSupply = /*#__PURE__*/ createUseReadContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "maxSupply",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"name"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useReadHenloPfpName = /*#__PURE__*/ createUseReadContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "name",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"owner"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useReadHenloPfpOwner = /*#__PURE__*/ createUseReadContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "owner",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"ownershipHandoverExpiresAt"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useReadHenloPfpOwnershipHandoverExpiresAt = /*#__PURE__*/ createUseReadContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "ownershipHandoverExpiresAt",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"price"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useReadHenloPfpPrice = /*#__PURE__*/ createUseReadContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "price",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"supportsInterface"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useReadHenloPfpSupportsInterface = /*#__PURE__*/ createUseReadContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "supportsInterface",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"symbol"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useReadHenloPfpSymbol = /*#__PURE__*/ createUseReadContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "symbol",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"totalSupply"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useReadHenloPfpTotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "totalSupply",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"uri"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useReadHenloPfpUri = /*#__PURE__*/ createUseReadContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "uri",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfp = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"cancelOwnershipHandover"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfpCancelOwnershipHandover = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "cancelOwnershipHandover",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"completeOwnershipHandover"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfpCompleteOwnershipHandover = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "completeOwnershipHandover",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"mint"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfpMint = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "mint",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfpRenounceOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"requestOwnershipHandover"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfpRequestOwnershipHandover = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "requestOwnershipHandover",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"safeBatchTransferFrom"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfpSafeBatchTransferFrom = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "safeBatchTransferFrom",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"safeTransferFrom"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfpSafeTransferFrom = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "safeTransferFrom",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"setApprovalForAll"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfpSetApprovalForAll = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "setApprovalForAll",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"setBaseURI"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfpSetBaseUri = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "setBaseURI",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"setMaxSupply"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfpSetMaxSupply = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "setMaxSupply",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"setPrice"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfpSetPrice = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "setPrice",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfpTransferOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"withdraw"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWriteHenloPfpWithdraw = /*#__PURE__*/ createUseWriteContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "withdraw",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfp = /*#__PURE__*/ createUseSimulateContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"cancelOwnershipHandover"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfpCancelOwnershipHandover = /*#__PURE__*/ createUseSimulateContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "cancelOwnershipHandover",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"completeOwnershipHandover"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfpCompleteOwnershipHandover = /*#__PURE__*/ createUseSimulateContract(
  {
    abi: henloPfpAbi,
    address: henloPfpAddress,
    functionName: "completeOwnershipHandover",
  },
);

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"mint"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfpMint = /*#__PURE__*/ createUseSimulateContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "mint",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfpRenounceOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"requestOwnershipHandover"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfpRequestOwnershipHandover = /*#__PURE__*/ createUseSimulateContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "requestOwnershipHandover",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"safeBatchTransferFrom"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfpSafeBatchTransferFrom = /*#__PURE__*/ createUseSimulateContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "safeBatchTransferFrom",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"safeTransferFrom"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfpSafeTransferFrom = /*#__PURE__*/ createUseSimulateContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "safeTransferFrom",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"setApprovalForAll"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfpSetApprovalForAll = /*#__PURE__*/ createUseSimulateContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "setApprovalForAll",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"setBaseURI"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfpSetBaseUri = /*#__PURE__*/ createUseSimulateContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "setBaseURI",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"setMaxSupply"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfpSetMaxSupply = /*#__PURE__*/ createUseSimulateContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "setMaxSupply",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"setPrice"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfpSetPrice = /*#__PURE__*/ createUseSimulateContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "setPrice",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfpTransferOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloPfpAbi}__ and `functionName` set to `"withdraw"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useSimulateHenloPfpWithdraw = /*#__PURE__*/ createUseSimulateContract({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  functionName: "withdraw",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloPfpAbi}__
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWatchHenloPfpEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloPfpAbi,
  address: henloPfpAddress,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloPfpAbi}__ and `eventName` set to `"ApprovalForAll"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWatchHenloPfpApprovalForAllEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  eventName: "ApprovalForAll",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloPfpAbi}__ and `eventName` set to `"OwnershipHandoverCanceled"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWatchHenloPfpOwnershipHandoverCanceledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: henloPfpAbi,
    address: henloPfpAddress,
    eventName: "OwnershipHandoverCanceled",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloPfpAbi}__ and `eventName` set to `"OwnershipHandoverRequested"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWatchHenloPfpOwnershipHandoverRequestedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: henloPfpAbi,
    address: henloPfpAddress,
    eventName: "OwnershipHandoverRequested",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloPfpAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWatchHenloPfpOwnershipTransferredEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  eventName: "OwnershipTransferred",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloPfpAbi}__ and `eventName` set to `"TransferBatch"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWatchHenloPfpTransferBatchEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  eventName: "TransferBatch",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloPfpAbi}__ and `eventName` set to `"TransferSingle"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWatchHenloPfpTransferSingleEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  eventName: "TransferSingle",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloPfpAbi}__ and `eventName` set to `"URI"`
 *
 * [__View Contract on Berachain B Artio Berachain B Artio Beratrail__](https://bartio.beratrail.io/address/0x0982c808B42A72d256d7E9d3BdF61e44ef31230d)
 */
export const useWatchHenloPfpUriEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloPfpAbi,
  address: henloPfpAddress,
  eventName: "URI",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVault = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"FEE_BASIS"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultFeeBasis = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "FEE_BASIS",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"MAX_FEE"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultMaxFee = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "MAX_FEE",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"asset"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultAsset = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "asset",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"canRedeem"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultCanRedeem = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "canRedeem",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"deployments"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultDeployments = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "deployments",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"epochs"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultEpochs = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "epochs",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"fee"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultFee = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "fee",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"getOracleKey"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultGetOracleKey = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "getOracleKey",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"getRoundInfo"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultGetRoundInfo = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "getRoundInfo",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"hodlMulti"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultHodlMulti = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "hodlMulti",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"infos"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultInfos = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "infos",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"nextId"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultNextId = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "nextId",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"oracle"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultOracle = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "oracle",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"oracleSender"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultOracleSender = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "oracleSender",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"owner"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultOwner = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "owner",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"paused"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultPaused = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "paused",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"previewMint"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultPreviewMint = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "previewMint",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"treasury"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useReadHenloVaultTreasury = /*#__PURE__*/ createUseReadContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "treasury",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVault = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"deployERC20"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultDeployErc20 = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "deployERC20",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"mint"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultMint = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "mint",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"openRound"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultOpenRound = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "openRound",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"pause"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultPause = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "pause",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"pauseDeposits"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultPauseDeposits = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "pauseDeposits",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"redeem"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultRedeem = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "redeem",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultRenounceOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"setFee"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultSetFee = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "setFee",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"setOracle"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultSetOracle = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "setOracle",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"setOracleKey"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultSetOracleKey = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "setOracleKey",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"setOracleSender"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultSetOracleSender = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "setOracleSender",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"setTreasury"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultSetTreasury = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "setTreasury",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultTransferOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"unpause"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultUnpause = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "unpause",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"unpauseDeposits"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultUnpauseDeposits = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "unpauseDeposits",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"updateDepositLimit"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWriteHenloVaultUpdateDepositLimit = /*#__PURE__*/ createUseWriteContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "updateDepositLimit",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVault = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"deployERC20"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultDeployErc20 = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "deployERC20",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"mint"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultMint = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "mint",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"openRound"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultOpenRound = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "openRound",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"pause"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultPause = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "pause",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"pauseDeposits"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultPauseDeposits = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "pauseDeposits",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"redeem"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultRedeem = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "redeem",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultRenounceOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"setFee"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultSetFee = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "setFee",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"setOracle"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultSetOracle = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "setOracle",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"setOracleKey"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultSetOracleKey = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "setOracleKey",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"setOracleSender"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultSetOracleSender = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "setOracleSender",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"setTreasury"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultSetTreasury = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "setTreasury",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultTransferOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"unpause"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultUnpause = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "unpause",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"unpauseDeposits"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultUnpauseDeposits = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "unpauseDeposits",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link henloVaultAbi}__ and `functionName` set to `"updateDepositLimit"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useSimulateHenloVaultUpdateDepositLimit = /*#__PURE__*/ createUseSimulateContract({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  functionName: "updateDepositLimit",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"DeployERC20"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultDeployErc20Event = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "DeployERC20",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"DepositLimitUpdated"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultDepositLimitUpdatedEvent = /*#__PURE__*/ createUseWatchContractEvent(
  {
    abi: henloVaultAbi,
    address: henloVaultAddress,
    eventName: "DepositLimitUpdated",
  },
);

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"DepositsPaused"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultDepositsPausedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "DepositsPaused",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"DepositsUnpaused"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultDepositsUnpausedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "DepositsUnpaused",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"Mint"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultMintEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "Mint",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"MintFromReservoir"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultMintFromReservoirEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "MintFromReservoir",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"OracleKeyUpdated"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultOracleKeyUpdatedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "OracleKeyUpdated",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"OracleSenderUpdated"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultOracleSenderUpdatedEvent = /*#__PURE__*/ createUseWatchContractEvent(
  {
    abi: henloVaultAbi,
    address: henloVaultAddress,
    eventName: "OracleSenderUpdated",
  },
);

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"OracleUpdated"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultOracleUpdatedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "OracleUpdated",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultOwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: henloVaultAbi,
    address: henloVaultAddress,
    eventName: "OwnershipTransferred",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"Paused"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultPausedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "Paused",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"Redeem"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultRedeemEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "Redeem",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"RoundClosed"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultRoundClosedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "RoundClosed",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"RoundOpened"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultRoundOpenedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "RoundOpened",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"SetFee"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultSetFeeEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "SetFee",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"SetTreasury"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultSetTreasuryEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "SetTreasury",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link henloVaultAbi}__ and `eventName` set to `"Unpaused"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x42069E3BF367C403b632CF9cD5a8d61e2c0c44fC)
 */
export const useWatchHenloVaultUnpausedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: henloVaultAbi,
  address: henloVaultAddress,
  eventName: "Unpaused",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ichiVaultAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xcb42b9d09d8da230d0390728c6f236511fac403b)
 */
export const useReadIchiVault = /*#__PURE__*/ createUseReadContract({
  abi: ichiVaultAbi,
  address: ichiVaultAddress,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ichiVaultAbi}__ and `functionName` set to `"getReserves"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xcb42b9d09d8da230d0390728c6f236511fac403b)
 */
export const useReadIchiVaultGetReserves = /*#__PURE__*/ createUseReadContract({
  abi: ichiVaultAbi,
  address: ichiVaultAddress,
  functionName: "getReserves",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ichiVaultAbi}__ and `functionName` set to `"token0"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xcb42b9d09d8da230d0390728c6f236511fac403b)
 */
export const useReadIchiVaultToken0 = /*#__PURE__*/ createUseReadContract({
  abi: ichiVaultAbi,
  address: ichiVaultAddress,
  functionName: "token0",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ichiVaultAbi}__ and `functionName` set to `"token1"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xcb42b9d09d8da230d0390728c6f236511fac403b)
 */
export const useReadIchiVaultToken1 = /*#__PURE__*/ createUseReadContract({
  abi: ichiVaultAbi,
  address: ichiVaultAddress,
  functionName: "token1",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ichiVaultAbi}__ and `functionName` set to `"totalSupply"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0xcb42b9d09d8da230d0390728c6f236511fac403b)
 */
export const useReadIchiVaultTotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: ichiVaultAbi,
  address: ichiVaultAddress,
  functionName: "totalSupply",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ramenHenloAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useReadRamenHenlo = /*#__PURE__*/ createUseReadContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ramenHenloAbi}__ and `functionName` set to `"allowance"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useReadRamenHenloAllowance = /*#__PURE__*/ createUseReadContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  functionName: "allowance",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ramenHenloAbi}__ and `functionName` set to `"balanceOf"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useReadRamenHenloBalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  functionName: "balanceOf",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ramenHenloAbi}__ and `functionName` set to `"decimals"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useReadRamenHenloDecimals = /*#__PURE__*/ createUseReadContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  functionName: "decimals",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ramenHenloAbi}__ and `functionName` set to `"name"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useReadRamenHenloName = /*#__PURE__*/ createUseReadContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  functionName: "name",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ramenHenloAbi}__ and `functionName` set to `"symbol"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useReadRamenHenloSymbol = /*#__PURE__*/ createUseReadContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  functionName: "symbol",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link ramenHenloAbi}__ and `functionName` set to `"totalSupply"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useReadRamenHenloTotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  functionName: "totalSupply",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ramenHenloAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useWriteRamenHenlo = /*#__PURE__*/ createUseWriteContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ramenHenloAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useWriteRamenHenloApprove = /*#__PURE__*/ createUseWriteContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  functionName: "approve",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ramenHenloAbi}__ and `functionName` set to `"transfer"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useWriteRamenHenloTransfer = /*#__PURE__*/ createUseWriteContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  functionName: "transfer",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link ramenHenloAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useWriteRamenHenloTransferFrom = /*#__PURE__*/ createUseWriteContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  functionName: "transferFrom",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ramenHenloAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useSimulateRamenHenlo = /*#__PURE__*/ createUseSimulateContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ramenHenloAbi}__ and `functionName` set to `"approve"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useSimulateRamenHenloApprove = /*#__PURE__*/ createUseSimulateContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  functionName: "approve",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ramenHenloAbi}__ and `functionName` set to `"transfer"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useSimulateRamenHenloTransfer = /*#__PURE__*/ createUseSimulateContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  functionName: "transfer",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link ramenHenloAbi}__ and `functionName` set to `"transferFrom"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useSimulateRamenHenloTransferFrom = /*#__PURE__*/ createUseSimulateContract({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  functionName: "transferFrom",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ramenHenloAbi}__
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useWatchRamenHenloEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ramenHenloAbi}__ and `eventName` set to `"Approval"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useWatchRamenHenloApprovalEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  eventName: "Approval",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link ramenHenloAbi}__ and `eventName` set to `"Transfer"`
 *
 * [__View Contract on Berachain Berascan__](https://berascan.com/address/0x371b36BCD10F6801ebbc578Af897624cc4130146)
 */
export const useWatchRamenHenloTransferEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: ramenHenloAbi,
  address: ramenHenloAddress,
  eventName: "Transfer",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__
 */
export const useReadReservoir = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"HENLO"`
 */
export const useReadReservoirHenlo = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "HENLO",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"endTime"`
 */
export const useReadReservoirEndTime = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "endTime",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"owner"`
 */
export const useReadReservoirOwner = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "owner",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"plHENLO"`
 */
export const useReadReservoirPlHenlo = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "plHENLO",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"plHENLOPerHENLO"`
 */
export const useReadReservoirPlHenloPerHenlo = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "plHENLOPerHENLO",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"settled"`
 */
export const useReadReservoirSettled = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "settled",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"startTime"`
 */
export const useReadReservoirStartTime = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "startTime",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"started"`
 */
export const useReadReservoirStarted = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "started",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"strike"`
 */
export const useReadReservoirStrike = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "strike",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"supportsInterface"`
 */
export const useReadReservoirSupportsInterface = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "supportsInterface",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"totalMatched"`
 */
export const useReadReservoirTotalMatched = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "totalMatched",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"totalWhitelistDeposit"`
 */
export const useReadReservoirTotalWhitelistDeposit = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "totalWhitelistDeposit",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"vault"`
 */
export const useReadReservoirVault = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "vault",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"whitelistDeposit"`
 */
export const useReadReservoirWhitelistDeposit = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "whitelistDeposit",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"whitelisted"`
 */
export const useReadReservoirWhitelisted = /*#__PURE__*/ createUseReadContract({
  abi: reservoirAbi,
  functionName: "whitelisted",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link reservoirAbi}__
 */
export const useWriteReservoir = /*#__PURE__*/ createUseWriteContract({
  abi: reservoirAbi,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"addWhitelist"`
 */
export const useWriteReservoirAddWhitelist = /*#__PURE__*/ createUseWriteContract({
  abi: reservoirAbi,
  functionName: "addWhitelist",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"claimWhitelist"`
 */
export const useWriteReservoirClaimWhitelist = /*#__PURE__*/ createUseWriteContract({
  abi: reservoirAbi,
  functionName: "claimWhitelist",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"depositWhitelist"`
 */
export const useWriteReservoirDepositWhitelist = /*#__PURE__*/ createUseWriteContract({
  abi: reservoirAbi,
  functionName: "depositWhitelist",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"incrementMatched"`
 */
export const useWriteReservoirIncrementMatched = /*#__PURE__*/ createUseWriteContract({
  abi: reservoirAbi,
  functionName: "incrementMatched",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"matchMint"`
 */
export const useWriteReservoirMatchMint = /*#__PURE__*/ createUseWriteContract({
  abi: reservoirAbi,
  functionName: "matchMint",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"onERC1155BatchReceived"`
 */
export const useWriteReservoirOnErc1155BatchReceived = /*#__PURE__*/ createUseWriteContract({
  abi: reservoirAbi,
  functionName: "onERC1155BatchReceived",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"onERC1155Received"`
 */
export const useWriteReservoirOnErc1155Received = /*#__PURE__*/ createUseWriteContract({
  abi: reservoirAbi,
  functionName: "onERC1155Received",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"removeWhitelist"`
 */
export const useWriteReservoirRemoveWhitelist = /*#__PURE__*/ createUseWriteContract({
  abi: reservoirAbi,
  functionName: "removeWhitelist",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useWriteReservoirRenounceOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: reservoirAbi,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"settle"`
 */
export const useWriteReservoirSettle = /*#__PURE__*/ createUseWriteContract({
  abi: reservoirAbi,
  functionName: "settle",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"startCampagin"`
 */
export const useWriteReservoirStartCampagin = /*#__PURE__*/ createUseWriteContract({
  abi: reservoirAbi,
  functionName: "startCampagin",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useWriteReservoirTransferOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: reservoirAbi,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link reservoirAbi}__
 */
export const useSimulateReservoir = /*#__PURE__*/ createUseSimulateContract({
  abi: reservoirAbi,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"addWhitelist"`
 */
export const useSimulateReservoirAddWhitelist = /*#__PURE__*/ createUseSimulateContract({
  abi: reservoirAbi,
  functionName: "addWhitelist",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"claimWhitelist"`
 */
export const useSimulateReservoirClaimWhitelist = /*#__PURE__*/ createUseSimulateContract({
  abi: reservoirAbi,
  functionName: "claimWhitelist",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"depositWhitelist"`
 */
export const useSimulateReservoirDepositWhitelist = /*#__PURE__*/ createUseSimulateContract({
  abi: reservoirAbi,
  functionName: "depositWhitelist",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"incrementMatched"`
 */
export const useSimulateReservoirIncrementMatched = /*#__PURE__*/ createUseSimulateContract({
  abi: reservoirAbi,
  functionName: "incrementMatched",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"matchMint"`
 */
export const useSimulateReservoirMatchMint = /*#__PURE__*/ createUseSimulateContract({
  abi: reservoirAbi,
  functionName: "matchMint",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"onERC1155BatchReceived"`
 */
export const useSimulateReservoirOnErc1155BatchReceived = /*#__PURE__*/ createUseSimulateContract({
  abi: reservoirAbi,
  functionName: "onERC1155BatchReceived",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"onERC1155Received"`
 */
export const useSimulateReservoirOnErc1155Received = /*#__PURE__*/ createUseSimulateContract({
  abi: reservoirAbi,
  functionName: "onERC1155Received",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"removeWhitelist"`
 */
export const useSimulateReservoirRemoveWhitelist = /*#__PURE__*/ createUseSimulateContract({
  abi: reservoirAbi,
  functionName: "removeWhitelist",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useSimulateReservoirRenounceOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: reservoirAbi,
  functionName: "renounceOwnership",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"settle"`
 */
export const useSimulateReservoirSettle = /*#__PURE__*/ createUseSimulateContract({
  abi: reservoirAbi,
  functionName: "settle",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"startCampagin"`
 */
export const useSimulateReservoirStartCampagin = /*#__PURE__*/ createUseSimulateContract({
  abi: reservoirAbi,
  functionName: "startCampagin",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link reservoirAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useSimulateReservoirTransferOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: reservoirAbi,
  functionName: "transferOwnership",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link reservoirAbi}__
 */
export const useWatchReservoirEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: reservoirAbi,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link reservoirAbi}__ and `eventName` set to `"AddedToWhiteList"`
 */
export const useWatchReservoirAddedToWhiteListEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: reservoirAbi,
  eventName: "AddedToWhiteList",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link reservoirAbi}__ and `eventName` set to `"CampaginStarted"`
 */
export const useWatchReservoirCampaginStartedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: reservoirAbi,
  eventName: "CampaginStarted",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link reservoirAbi}__ and `eventName` set to `"MatchedAmountIncremented"`
 */
export const useWatchReservoirMatchedAmountIncrementedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: reservoirAbi,
    eventName: "MatchedAmountIncremented",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link reservoirAbi}__ and `eventName` set to `"OwnershipTransferred"`
 */
export const useWatchReservoirOwnershipTransferredEvent = /*#__PURE__*/ createUseWatchContractEvent(
  {
    abi: reservoirAbi,
    eventName: "OwnershipTransferred",
  },
);

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link reservoirAbi}__ and `eventName` set to `"RemovedFromWhitelist"`
 */
export const useWatchReservoirRemovedFromWhitelistEvent = /*#__PURE__*/ createUseWatchContractEvent(
  {
    abi: reservoirAbi,
    eventName: "RemovedFromWhitelist",
  },
);

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link reservoirAbi}__ and `eventName` set to `"WhitelistClaim"`
 */
export const useWatchReservoirWhitelistClaimEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: reservoirAbi,
  eventName: "WhitelistClaim",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link reservoirAbi}__ and `eventName` set to `"WhitelistDeposit"`
 */
export const useWatchReservoirWhitelistDepositEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: reservoirAbi,
  eventName: "WhitelistDeposit",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__
 */
export const useReadRewardVault = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"MAX_REWARD_DURATION"`
 */
export const useReadRewardVaultMaxRewardDuration = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "MAX_REWARD_DURATION",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"MIN_REWARD_DURATION"`
 */
export const useReadRewardVaultMinRewardDuration = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "MIN_REWARD_DURATION",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadRewardVaultBalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "balanceOf",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"beaconDepositContract"`
 */
export const useReadRewardVaultBeaconDepositContract = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "beaconDepositContract",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"distributor"`
 */
export const useReadRewardVaultDistributor = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "distributor",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"earned"`
 */
export const useReadRewardVaultEarned = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "earned",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"factory"`
 */
export const useReadRewardVaultFactory = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "factory",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"getDelegateStake"`
 */
export const useReadRewardVaultGetDelegateStake = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "getDelegateStake",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"getRewardForDuration"`
 */
export const useReadRewardVaultGetRewardForDuration = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "getRewardForDuration",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"getTotalDelegateStaked"`
 */
export const useReadRewardVaultGetTotalDelegateStaked = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "getTotalDelegateStaked",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"getWhitelistedTokens"`
 */
export const useReadRewardVaultGetWhitelistedTokens = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "getWhitelistedTokens",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"getWhitelistedTokensCount"`
 */
export const useReadRewardVaultGetWhitelistedTokensCount = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "getWhitelistedTokensCount",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"incentives"`
 */
export const useReadRewardVaultIncentives = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "incentives",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"isFactoryOwner"`
 */
export const useReadRewardVaultIsFactoryOwner = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "isFactoryOwner",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"isFactoryVaultManager"`
 */
export const useReadRewardVaultIsFactoryVaultManager = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "isFactoryVaultManager",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"isFactoryVaultPauser"`
 */
export const useReadRewardVaultIsFactoryVaultPauser = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "isFactoryVaultPauser",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"lastTimeRewardApplicable"`
 */
export const useReadRewardVaultLastTimeRewardApplicable = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "lastTimeRewardApplicable",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"lastUpdateTime"`
 */
export const useReadRewardVaultLastUpdateTime = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "lastUpdateTime",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"maxIncentiveTokensCount"`
 */
export const useReadRewardVaultMaxIncentiveTokensCount = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "maxIncentiveTokensCount",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"minRewardDurationForTargetRate"`
 */
export const useReadRewardVaultMinRewardDurationForTargetRate = /*#__PURE__*/ createUseReadContract(
  {
    abi: rewardVaultAbi,
    functionName: "minRewardDurationForTargetRate",
  },
);

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"operator"`
 */
export const useReadRewardVaultOperator = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "operator",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"paused"`
 */
export const useReadRewardVaultPaused = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "paused",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"pendingRewardsDuration"`
 */
export const useReadRewardVaultPendingRewardsDuration = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "pendingRewardsDuration",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"periodFinish"`
 */
export const useReadRewardVaultPeriodFinish = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "periodFinish",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"rewardPerToken"`
 */
export const useReadRewardVaultRewardPerToken = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "rewardPerToken",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"rewardPerTokenStored"`
 */
export const useReadRewardVaultRewardPerTokenStored = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "rewardPerTokenStored",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"rewardRate"`
 */
export const useReadRewardVaultRewardRate = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "rewardRate",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"rewardToken"`
 */
export const useReadRewardVaultRewardToken = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "rewardToken",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"rewardVaultManager"`
 */
export const useReadRewardVaultRewardVaultManager = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "rewardVaultManager",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"rewards"`
 */
export const useReadRewardVaultRewards = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "rewards",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"rewardsDuration"`
 */
export const useReadRewardVaultRewardsDuration = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "rewardsDuration",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"stakeToken"`
 */
export const useReadRewardVaultStakeToken = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "stakeToken",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"targetRewardsPerSecond"`
 */
export const useReadRewardVaultTargetRewardsPerSecond = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "targetRewardsPerSecond",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadRewardVaultTotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "totalSupply",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"undistributedRewards"`
 */
export const useReadRewardVaultUndistributedRewards = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "undistributedRewards",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"userRewardPerTokenPaid"`
 */
export const useReadRewardVaultUserRewardPerTokenPaid = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "userRewardPerTokenPaid",
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"whitelistedTokens"`
 */
export const useReadRewardVaultWhitelistedTokens = /*#__PURE__*/ createUseReadContract({
  abi: rewardVaultAbi,
  functionName: "whitelistedTokens",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__
 */
export const useWriteRewardVault = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"accountIncentives"`
 */
export const useWriteRewardVaultAccountIncentives = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "accountIncentives",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"addIncentive"`
 */
export const useWriteRewardVaultAddIncentive = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "addIncentive",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"delegateStake"`
 */
export const useWriteRewardVaultDelegateStake = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "delegateStake",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"delegateWithdraw"`
 */
export const useWriteRewardVaultDelegateWithdraw = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "delegateWithdraw",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"exit"`
 */
export const useWriteRewardVaultExit = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "exit",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"getPartialReward"`
 */
export const useWriteRewardVaultGetPartialReward = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "getPartialReward",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"getReward"`
 */
export const useWriteRewardVaultGetReward = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "getReward",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"initialize"`
 */
export const useWriteRewardVaultInitialize = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "initialize",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"notifyRewardAmount"`
 */
export const useWriteRewardVaultNotifyRewardAmount = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "notifyRewardAmount",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"pause"`
 */
export const useWriteRewardVaultPause = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "pause",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"recoverERC20"`
 */
export const useWriteRewardVaultRecoverErc20 = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "recoverERC20",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"removeIncentiveToken"`
 */
export const useWriteRewardVaultRemoveIncentiveToken = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "removeIncentiveToken",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setDistributor"`
 */
export const useWriteRewardVaultSetDistributor = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "setDistributor",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setMaxIncentiveTokensCount"`
 */
export const useWriteRewardVaultSetMaxIncentiveTokensCount = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "setMaxIncentiveTokensCount",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setMinRewardDurationForTargetRate"`
 */
export const useWriteRewardVaultSetMinRewardDurationForTargetRate =
  /*#__PURE__*/ createUseWriteContract({
    abi: rewardVaultAbi,
    functionName: "setMinRewardDurationForTargetRate",
  });

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setOperator"`
 */
export const useWriteRewardVaultSetOperator = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "setOperator",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setRewardVaultManager"`
 */
export const useWriteRewardVaultSetRewardVaultManager = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "setRewardVaultManager",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setRewardsDuration"`
 */
export const useWriteRewardVaultSetRewardsDuration = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "setRewardsDuration",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setTargetRewardsPerSecond"`
 */
export const useWriteRewardVaultSetTargetRewardsPerSecond = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "setTargetRewardsPerSecond",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"stake"`
 */
export const useWriteRewardVaultStake = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "stake",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"stakeOnBehalf"`
 */
export const useWriteRewardVaultStakeOnBehalf = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "stakeOnBehalf",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"unpause"`
 */
export const useWriteRewardVaultUnpause = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "unpause",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"updateIncentiveManager"`
 */
export const useWriteRewardVaultUpdateIncentiveManager = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "updateIncentiveManager",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"whitelistIncentiveToken"`
 */
export const useWriteRewardVaultWhitelistIncentiveToken = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "whitelistIncentiveToken",
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"withdraw"`
 */
export const useWriteRewardVaultWithdraw = /*#__PURE__*/ createUseWriteContract({
  abi: rewardVaultAbi,
  functionName: "withdraw",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__
 */
export const useSimulateRewardVault = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"accountIncentives"`
 */
export const useSimulateRewardVaultAccountIncentives = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "accountIncentives",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"addIncentive"`
 */
export const useSimulateRewardVaultAddIncentive = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "addIncentive",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"delegateStake"`
 */
export const useSimulateRewardVaultDelegateStake = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "delegateStake",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"delegateWithdraw"`
 */
export const useSimulateRewardVaultDelegateWithdraw = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "delegateWithdraw",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"exit"`
 */
export const useSimulateRewardVaultExit = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "exit",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"getPartialReward"`
 */
export const useSimulateRewardVaultGetPartialReward = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "getPartialReward",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"getReward"`
 */
export const useSimulateRewardVaultGetReward = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "getReward",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"initialize"`
 */
export const useSimulateRewardVaultInitialize = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "initialize",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"notifyRewardAmount"`
 */
export const useSimulateRewardVaultNotifyRewardAmount = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "notifyRewardAmount",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"pause"`
 */
export const useSimulateRewardVaultPause = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "pause",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"recoverERC20"`
 */
export const useSimulateRewardVaultRecoverErc20 = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "recoverERC20",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"removeIncentiveToken"`
 */
export const useSimulateRewardVaultRemoveIncentiveToken = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "removeIncentiveToken",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setDistributor"`
 */
export const useSimulateRewardVaultSetDistributor = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "setDistributor",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setMaxIncentiveTokensCount"`
 */
export const useSimulateRewardVaultSetMaxIncentiveTokensCount =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardVaultAbi,
    functionName: "setMaxIncentiveTokensCount",
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setMinRewardDurationForTargetRate"`
 */
export const useSimulateRewardVaultSetMinRewardDurationForTargetRate =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardVaultAbi,
    functionName: "setMinRewardDurationForTargetRate",
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setOperator"`
 */
export const useSimulateRewardVaultSetOperator = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "setOperator",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setRewardVaultManager"`
 */
export const useSimulateRewardVaultSetRewardVaultManager = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "setRewardVaultManager",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setRewardsDuration"`
 */
export const useSimulateRewardVaultSetRewardsDuration = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "setRewardsDuration",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"setTargetRewardsPerSecond"`
 */
export const useSimulateRewardVaultSetTargetRewardsPerSecond =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardVaultAbi,
    functionName: "setTargetRewardsPerSecond",
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"stake"`
 */
export const useSimulateRewardVaultStake = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "stake",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"stakeOnBehalf"`
 */
export const useSimulateRewardVaultStakeOnBehalf = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "stakeOnBehalf",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"unpause"`
 */
export const useSimulateRewardVaultUnpause = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "unpause",
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"updateIncentiveManager"`
 */
export const useSimulateRewardVaultUpdateIncentiveManager = /*#__PURE__*/ createUseSimulateContract(
  {
    abi: rewardVaultAbi,
    functionName: "updateIncentiveManager",
  },
);

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"whitelistIncentiveToken"`
 */
export const useSimulateRewardVaultWhitelistIncentiveToken =
  /*#__PURE__*/ createUseSimulateContract({
    abi: rewardVaultAbi,
    functionName: "whitelistIncentiveToken",
  });

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rewardVaultAbi}__ and `functionName` set to `"withdraw"`
 */
export const useSimulateRewardVaultWithdraw = /*#__PURE__*/ createUseSimulateContract({
  abi: rewardVaultAbi,
  functionName: "withdraw",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__
 */
export const useWatchRewardVaultEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"BGTBoosterIncentivesProcessFailed"`
 */
export const useWatchRewardVaultBgtBoosterIncentivesProcessFailedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "BGTBoosterIncentivesProcessFailed",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"BGTBoosterIncentivesProcessed"`
 */
export const useWatchRewardVaultBgtBoosterIncentivesProcessedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "BGTBoosterIncentivesProcessed",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"DelegateStaked"`
 */
export const useWatchRewardVaultDelegateStakedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
  eventName: "DelegateStaked",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"DelegateWithdrawn"`
 */
export const useWatchRewardVaultDelegateWithdrawnEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
  eventName: "DelegateWithdrawn",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"DistributorSet"`
 */
export const useWatchRewardVaultDistributorSetEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
  eventName: "DistributorSet",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"IncentiveAdded"`
 */
export const useWatchRewardVaultIncentiveAddedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
  eventName: "IncentiveAdded",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"IncentiveFeeCollected"`
 */
export const useWatchRewardVaultIncentiveFeeCollectedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "IncentiveFeeCollected",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"IncentiveFeeCollectionFailed"`
 */
export const useWatchRewardVaultIncentiveFeeCollectionFailedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "IncentiveFeeCollectionFailed",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"IncentiveManagerChanged"`
 */
export const useWatchRewardVaultIncentiveManagerChangedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "IncentiveManagerChanged",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"IncentiveTokenRemoved"`
 */
export const useWatchRewardVaultIncentiveTokenRemovedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "IncentiveTokenRemoved",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"IncentiveTokenWhitelisted"`
 */
export const useWatchRewardVaultIncentiveTokenWhitelistedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "IncentiveTokenWhitelisted",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"IncentivesProcessFailed"`
 */
export const useWatchRewardVaultIncentivesProcessFailedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "IncentivesProcessFailed",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"IncentivesProcessed"`
 */
export const useWatchRewardVaultIncentivesProcessedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "IncentivesProcessed",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"Initialized"`
 */
export const useWatchRewardVaultInitializedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
  eventName: "Initialized",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"MaxIncentiveTokensCountUpdated"`
 */
export const useWatchRewardVaultMaxIncentiveTokensCountUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "MaxIncentiveTokensCountUpdated",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"MinRewardDurationForTargetRateUpdated"`
 */
export const useWatchRewardVaultMinRewardDurationForTargetRateUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "MinRewardDurationForTargetRateUpdated",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"OperatorSet"`
 */
export const useWatchRewardVaultOperatorSetEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
  eventName: "OperatorSet",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"Paused"`
 */
export const useWatchRewardVaultPausedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
  eventName: "Paused",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"Recovered"`
 */
export const useWatchRewardVaultRecoveredEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
  eventName: "Recovered",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"RewardAdded"`
 */
export const useWatchRewardVaultRewardAddedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
  eventName: "RewardAdded",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"RewardPaid"`
 */
export const useWatchRewardVaultRewardPaidEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
  eventName: "RewardPaid",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"RewardVaultManagerSet"`
 */
export const useWatchRewardVaultRewardVaultManagerSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "RewardVaultManagerSet",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"RewardsDurationUpdated"`
 */
export const useWatchRewardVaultRewardsDurationUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "RewardsDurationUpdated",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"Staked"`
 */
export const useWatchRewardVaultStakedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
  eventName: "Staked",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"TargetRewardsPerSecondUpdated"`
 */
export const useWatchRewardVaultTargetRewardsPerSecondUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rewardVaultAbi,
    eventName: "TargetRewardsPerSecondUpdated",
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"Unpaused"`
 */
export const useWatchRewardVaultUnpausedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
  eventName: "Unpaused",
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rewardVaultAbi}__ and `eventName` set to `"Withdrawn"`
 */
export const useWatchRewardVaultWithdrawnEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rewardVaultAbi,
  eventName: "Withdrawn",
});
